// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:30.974Z
// Property: Nickel Creek Apts (ID: 6767906449165614)
// Collections: 37 amenities, 6 floorplans (live), 46 photos, 64 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165614",
  "property_external_id": "ldy0m3g",
  "property_zillow_url": "https://www.zillow.com/homedetails/7805-S-Union-Ave-Tulsa-OK-74132/309689301_zpid/",
  "property_apartments_url": "https://www.apartments.com/nickel-creek-apts-tulsa-ok/ldy0m3g/",
  "property_google_business_url": "https://www.google.com/maps/place/Nickel+Creek+Apartments/data=!4m2!3m1!1s0x0:0x481d2deed89327fb?sa=X&ved=2ahUKEwis45X4-7ySAxW8SzABHQOkPU4Q_BJ6BAhEEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "49866593977",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "nickel-creek-apts",
  "property_name": "Nickel Creek Apts",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/nickel-creek/",
  "property_domain": null,
  "property_address": "7805 South Union Avenue",
  "property_full_address": "7805 South Union Avenue, Tulsa, OK, 74132",
  "property_address_1": "7805 South Union Avenue",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "Oklahoma",
  "property_address_zip_full": null,
  "property_address_zip": "74132",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa County",
  "property_address_latitude": "36.0509",
  "property_address_longitude": "-96.0108",
  "property_email": "nickelcreek@caseusa.com",
  "property_phone": "(539) 208-8753",
  "property_call_tracking_phone": "844-966-4126",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Nickel Creek Apts in Tulsa, Oklahoma—a vibrant community featuring stylish one and two-bedroom floor plans. Your furry friend will love our spacious Bark Park, perfect for playdates. Find your new home today—browse our availability or schedule a tour to experience the charm of Nickel Creek! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to **Nickel Creek Apartments**, your premier destination for comfortable living in the heart of Tulsa, Oklahoma. Our community offers a diverse selection of thoughtfully designed floor plans, including spacious one-bedroom and two-bedroom apartments, perfect for singles, couples, or small families. At Nickel Creek, we prioritize your lifestyle and provide an array of amenities to enhance your living experience.\n\nOne of the standout features of our community is the on-site **Bark Park**, where your furry friends can roam freely and make new pals in a safe environment. Our beautifully landscaped grounds are complemented by a welcoming atmosphere, ideal for both relaxation and recreation. \n\nLocated in a vibrant neighborhood, Nickel Creek Apartments provide easy access to local attractions, shopping, dining, and entertainment, ensuring you are never far from the action. Enjoy the perfect blend of tranquility and convenience, making us the ideal choice for your next home.\n\nDon’t miss out on the opportunity to find your perfect living space at Nickel Creek Apartments. **Browse our availability today** to discover your new home or **schedule a tour** to experience our community firsthand. Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb42-e048-75f7-b3e7-ed568132432b.webp",
  "property_featured_image_media": {
    "alt_text": "Dining area with round wooden table and four chairs, large windows with blinds and curtains.",
    "public_id": "019cfb42-e048-75f7-b3e7-ed568132432b",
    "storage_key": "property/6767906449165614/019cfb42-e048-75f7-b3e7-ed568132432b.webp",
    "width": 2700,
    "height": 1800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "304",
  "property_year_built": "2009",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.36842105263158",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of two pets allowed. Breed restrictions apply.",
  "property_pet_policy_description": "No weight limit. Maximum of two pets allowed. Breed restrictions apply. Pet rent: $30 per pet, per month. One-time fee: $500 per pet (non-refundable). Service animals are not considered pets; pet fees and rent do not apply to them.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://nickelcreekapartmentstulsa.securecafe.com/onlineleasing/nickel-creek-apts/floorplans.aspx",
  "property_resident_portal_url": "https://nickelcreekapartmentstulsa.securecafe.com/residentservices/nickel-creek-apts/userlogin.aspx",
  "property_apply_now_url": "https://nickelcreekapartmentstulsa.securecafe.com/onlineleasing/nickel-creek-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-3fb2-71db-b3e4-38585067baf7.webp",
  "property_primary_logo_media": {
    "alt_text": "Nickel Creek at Tulsa Hills logo",
    "public_id": "019cfb43-3fb2-71db-b3e4-38585067baf7",
    "storage_key": "property/6767906449165614/019cfb43-3fb2-71db-b3e4-38585067baf7.webp",
    "width": 684,
    "height": 424
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb44-d30b-72bb-97a6-0604f0ed4bc0.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb44-d30b-72bb-97a6-0604f0ed4bc0",
    "storage_key": "property/6767906449165614/019cfb44-d30b-72bb-97a6-0604f0ed4bc0.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb44-e28c-77e5-bdcd-040366f8edea.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Nickel Creek at Tulsa Hills logo",
    "public_id": "019cfb44-e28c-77e5-bdcd-040366f8edea",
    "storage_key": "property/6767906449165614/019cfb44-e28c-77e5-bdcd-040366f8edea.webp",
    "width": 640,
    "height": 397
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb44-ea6d-7678-ab99-6e325d6bd33c.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Nickel Creek at Tulsa Hills logo",
    "public_id": "019cfb44-ea6d-7678-ab99-6e325d6bd33c",
    "storage_key": "property/6767906449165614/019cfb44-ea6d-7678-ab99-6e325d6bd33c.webp",
    "width": 640,
    "height": 397
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3d3d3f",
  "property_secondary_color": "#556771",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#eae0c8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1110",
  "property_sqft_min": "789",
  "property_sqft_max": "1,110",
  "property_price_range": "1069 - 1634",
  "property_price_min": "1069",
  "property_price_max": "1399",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/NickelCreekTulsa",
  "property_instagram_url": "https://www.instagram.com/nickelcreektulsahills/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJexcAYQCVtocR-yeT2O4tHUg",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/nickel-creek-tulsa",
  "property_tiktok_url": "https://www.tiktok.com/@nickelcreekapartments",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Nickel Creek Apts",
  "property_home_romance_title": "Embrace a New Beginning in Your Perfect Apartment Home",
  "property_home_amenities_blurb": "Welcome to Nickel Creek Apts in vibrant Tulsa, Oklahoma, where comfortable living meets modern convenience. Choose from spacious one- or two-bedroom floor plans tailored to your lifestyle. Enjoy sunny days at our bark park, perfect for furry friends and their owners. Experience the unique charm of our community today!",
  "property_home_floorplans_blurb": "At Nickel Creek Apts in Tulsa, Oklahoma, your ideal living space awaits. Choose from our thoughtfully designed one and two-bedroom floor plans, each crafted for comfort and style. Uncover the perfect setting for your lifestyle—browse our available apartment homes today and embrace a vibrant community you'll love calling home.",
  "property_home_gallery_blurb": "Welcome to Nickel Creek Apts in Tulsa, Oklahoma, where comfort meets community. Choose from spacious one and two-bedroom floor plans tailored to fit your lifestyle. Enjoy leisure time at our inviting bark park—perfect for pet lovers! Picture yourself living here and embrace the vibrant life waiting for you!",
  "property_home_neighborhood_blurb": "At Nickel Creek Apts in Tulsa, enjoy a vibrant lifestyle surrounded by enriching experiences. From the stunning landscapes of Gathering Place and Woodward Park to the cultural gems found at the Philbrook Museum of Art, our community is perfectly situated near local favorites for adventure and recreation. Explore your new neighborhood!",
  "property_home_reviews_blurb": "At Nickel Creek Apts, residents rave about our attentive maintenance, with one noting, “Michael had come and taken care of all of them, efficiently, and in a very friendly and respectful manner.” Enjoy a peaceful atmosphere in spacious apartments, conveniently located near Tulsa Hills shopping and dining. Come see for yourself!",
  "property_neighborhood_blurb": "At Nickel Creek Apts, adventure awaits just beyond your doorstep! Dive into culture at the Philbrook Museum of Art or discover the wonders of the Oklahoma Aquarium. With beautiful parks, inspiring educational institutions like Oral Roberts University, and engaging attractions such as Urban Air Trampoline Park, there’s something for everyone!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Nickel Creek Apts in Tulsa, Oklahoma, our inviting community is designed for comfort and convenience. Choose from spacious one- and two-bedroom floor plans, and let your furry friend roam free in our on-site bark park. Step into a lifestyle that feels like home—your new adventure awaits!",
  "property_applynow_blurb": "At Nickel Creek Apts in Tulsa, Oklahoma, find your perfect sanctuary with our thoughtfully designed one and two-bedroom floor plans. Embrace a pet-friendly lifestyle with our inviting Bark Park, where playtime awaits. Ready to elevate your living experience? Secure your new home and lease online today!",
  "property_contactus_blurb": "At Nickel Creek Apts in Tulsa, Oklahoma, you'll find the perfect space tailored to your lifestyle, whether you prefer a cozy one-bedroom or a spacious two-bedroom. Our diverse floor plans offer the ideal backdrop for your next chapter. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Nickel Creek Apts in Tulsa, Oklahoma, we offer thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Have questions? Our FAQs page is your go-to resource for everything you need to know about our vibrant community, ensuring a seamless living experience at Nickel Creek.",
  "property_floorplans_blurb": "At Nickel Creek Apts in Tulsa, Oklahoma, we offer thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Each layout combines comfort and functionality, providing a serene sanctuary to call home. Browse our available apartment homes and discover the ideal space tailored just for you.",
  "property_gallery_blurb": "At Nickel Creek Apts in Tulsa, Oklahoma, your ideal lifestyle awaits. From spacious one and two-bedroom floor plans to a welcoming bark park for your furry friends, every detail is designed for comfort. Picture yourself living here and capturing memories in our inviting community—where home truly feels like paradise!",
  "property_interactivemap_blurb": "Welcome to Nickel Creek Apartments in Tulsa, Oklahoma, where comfort meets convenience. Choose from our stylish one- and two-bedroom floor plans, and let your furry friends roam free in our dedicated Bark Park. Navigate your ideal space effortlessly with our interactive community map—your new adventure awaits!",
  "property_pets_blurb": "At Nickel Creek Apts in Tulsa, your furry companions are more than welcome—unleash joy with up to two pets by your side! With no weight limit and a vibrant community to explore, your four-legged friends will love calling our apartments home. Enjoy comfort and convenience in every pawstep.",
  "property_referafriend_blurb": "At Nickel Creek Apts in Tulsa, Oklahoma, we celebrate community! Choose from our spacious one- and two-bedroom floor plans, perfect for you and your friends. Great friends make great neighbors—refer a friend today and enjoy the warmth of home together at Nickel Creek. Your vibrant lifestyle awaits!",
  "property_residentaccess_blurb": "Welcome to Nickel Creek Apts in Tulsa, Oklahoma, where comfort meets convenience in our thoughtfully designed one and two-bedroom layouts. Unlock your community's benefits by accessing our resident portal—pay rent, schedule maintenance, and manage your living experience effortlessly, all from the palm of your hand. Enjoy your home!",
  "property_reviews_blurb": "At Nickel Creek Apartments in Tulsa, our residents rave about their experience! With a rating of 5 stars, one resident shares, “Maintenance is always on time, and the location makes everything super convenient.” Enjoy a peaceful atmosphere, spacious living, and a vibrant community—all just steps away from shopping and dining!",
  "property_created_at": "1753982387511",
  "property_scheduletour_blurb": "At Nickel Creek Apts in Tulsa, Oklahoma, choose from thoughtfully designed one and two-bedroom floor plans tailored for comfort and style. Experience the vibrant community atmosphere and unparalleled amenities. Curious about life here? Check out our residents' testimonials, and schedule a tour today to envision your new home!",
  "property_thankyou_blurb": "Thank you for connecting with Nickel Creek Apts in Tulsa! Whether you’re searching for a cozy one-bedroom retreat or a spacious two-bedroom haven, our thoughtfully designed floor plans promise comfort and style. A team member will be in touch soon to help you find your ideal home!",
  "property_virtualtours_blurb": "Welcome to Nickel Creek Apts in Tulsa, Oklahoma, where modern living meets comfort. Our thoughtfully designed floor plans include stylish one and two-bedroom options tailored to your lifestyle. Experience the community's charm—take a virtual tour today and envision your new home! ",
  "property_copyright": "2026 All Rights Reserved. Nickel Creek Apts",
  "property_seo_title_home": "Nickel Creek Apts |  Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Discover Nickel Creek Apts in Tulsa! Choose stylish one or two-bedroom units and enjoy our welcoming bark park for your furry friends.",
  "property_seo_title_floorplans": "Floor Plans | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Nickel Creek Apts in Tulsa! View our unique one and two-bedroom floor plans and make your dream home a reality.",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Nickel Creek Apts in Tulsa! Enjoy spacious one & two-bedroom layouts, plus a fun Bark Park for your furry friends. Embrace stylish living today!",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "Picture your new life at Nickel Creek Apts in Tulsa—stunning one- and two-bedroom layouts, plus a fun bark park for furry friends. See the beauty unfold!",
  "property_seo_title_virtualtours": "Virtual Tours | Nickel Creek Apts Apartments",
  "property_seo_description_virtualtours": "Step inside Nickel Creek Apts in Tulsa! Experience spacious one and two-bedroom layouts through our immersive virtual tour. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Nickel Creek Apts Apartments",
  "property_seo_description_interactivemap": "Find your ideal space at Nickel Creek Apts in Tulsa! Unleash fun in our bark park and navigate options with our interactive map. Your new home awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Nickel Creek Apts in Tulsa, OK! Dive into the neighborhood’s unique gems, local favorites, and must-see attractions just beyond your door.",
  "property_seo_title_contact": "Contact Us | Nickel Creek Apts",
  "property_seo_description_contact": "Connect with Nickel Creek Apts in Tulsa! From cozy one-bedrooms to spacious two-bedrooms, our leasing team is ready to help you find your perfect home.",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "Find answers to your questions at Nickel Creek Apts in Tulsa! Explore our FAQs about floor plans, amenities like our bark park, and more!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "Join the Nickel Creek Apts community in Tulsa! Check out our residents' reviews and see why our one and two-bedroom homes and bark park are a perfect fit!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Discover Nickel Creek Apts in Tulsa! Stylish one and two-bedroom layouts await, plus a fantastic bark park for your furry friends!",
  "property_seo_title_residentaccess": "Resident Access | Nickel Creek Apts",
  "property_seo_description_residentaccess": "Seamless living at Nickel Creek Apts in Tulsa! Log in to your resident portal for hassle-free rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Nickel Creek Apts",
  "property_seo_description_referafriend": "Build your community at Nickel Creek Apts! Refer a friend and enjoy exclusive perks. Because great friends make the best neighbors in Tulsa, OK!",
  "property_seo_title_scheduletour": "Schedule a Tour | Nickel Creek Apts",
  "property_seo_description_scheduletour": "Discover Nickel Creek Apts in Tulsa—a tranquil oasis. Reserve your tour now and envision your new home in a vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Nickel Creek Apts",
  "property_seo_description_privacy": "At Nickel Creek Apts in Tulsa, your privacy is our priority. Learn how we protect your personal information and enjoy peace of mind in your new home.",
  "property_seo_title_accessibility": "Website Accessibility | Nickel Creek Apts",
  "property_seo_description_accessibility": "At Nickel Creek Apts in Tulsa, we prioritize digital inclusion. Dive into our accessibility statement to see how we create a welcoming community for all.",
  "property_seo_title_sitemap": "Sitemap | Nickel Creek Apts",
  "property_seo_description_sitemap": "Unearth your perfect home at Nickel Creek Apts in Tulsa! Navigate our sitemap for a glimpse into your future lifestyle. Your next adventure awaits!",
  "property_seo_title_thankyou": "Thank You | Nickel Creek Apts",
  "property_seo_description_thankyou": "Thank you for reaching out! A Nickel Creek Apts team member will soon connect with you to discuss your ideal living experience in Tulsa, Oklahoma. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, Oklahoma",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865459765",
  "amenities": [
    {
      "id": "ec_708c5a9bf05dd3c591489040",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Grill & Chill Area w/ Outdoor Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aebeef4b3afbfc2be11648a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Executive Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3088965b26ea5e90f6af3e58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4f302437422715f145180b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Limited‑Access Gates",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dbcd3adb4fb146406ed55874",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6e5ca165cb78b53da5cffb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dbf98169a0f18f4ec00b4964",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df49fbf938abe14b2547eb14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "High‑Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e99ddc4d134997e8f005d99d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6530470cecf5fb18a5de5b52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca4586c21d64fbd5d9d7c70a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Onsite Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db0c668dcb41050b36411ef1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfa3afbf7b0bc9931f3807af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f8371489172b1f47ba582545",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Close to Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a56f1b1ffedec44469e07caa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_201d412721bc6d601dcac0ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4aadd31916ea855bb8c5f07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_973475859875cb471987d877",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Located in Jenks Public School District",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_998d5d022a206aa67563e718",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Electronic Payments Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9319c7377027a03be7e2e039",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54aa264f4462511bf0042253",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_660fc79cf2d1315f17585f31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f78f471bba8777a86a9b0f28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4288d6568cc73095a686efee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54a85b2d618d0767dfae2122",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91083137c282d0d75a8a6625",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45fbe82061d5ea689e674059",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b48c09fb4761b0a137c4b264",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Fireplace*",
      "amount": "false",
      "description": "Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_895cab42c66fac28946bd8fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Ceramic Tile",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fe851d28cc32284a47df3b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63e4648647da62bc4a5d26b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_020bbc0cb51b898323818222",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Patio or Balcony*",
      "amount": "false",
      "description": "Available in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b00fcdc8b539098c8df426f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a281d0d56e7c93c4c6dc6857",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14d31ef91c839eac71a9ea61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca896172794955b3e1aab606",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Stove",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d01654a768e9716744bdda2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "external_id": "false",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_39616f72-8ab9-49fe-b42d-b2f24fe62b6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db132-8326-7461-8982-fcdd7f96379a.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019db132-8326-7461-8982-fcdd7f96379a",
        "storage_key": "property/6767906449165614/019db132-8326-7461-8982-fcdd7f96379a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, strength training equipment, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b5cc1234-6132-4d63-99e0-c4eab9536d7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db132-821b-7131-a87b-321a7b6f230d.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer, and seating.",
        "public_id": "019db132-821b-7131-a87b-321a7b6f230d",
        "storage_key": "property/6767906449165614/019db132-821b-7131-a87b-321a7b6f230d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay connected and productive in our resident business center, equipped with computers, a printer, and comfortable seating.",
      "link": "",
      "alt_text": "Business center with computers, printer, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb4e9e84-4fbc-4a63-b1c5-a40c10fd76d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db132-7d6d-722d-87db-6a64f7d52cf3.webp",
      "image_media": {
        "alt_text": "Stylish communal living room with a stone fireplace, comfortable seating, and decorative elements.",
        "public_id": "019db132-7d6d-722d-87db-6a64f7d52cf3",
        "storage_key": "property/6767906449165614/019db132-7d6d-722d-87db-6a64f7d52cf3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed communal living room, featuring a cozy stone fireplace and ample seating for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Stylish communal living room with a stone fireplace, comfortable seating, and decorative elements.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_03052339-5f66-4e6e-b8c2-213e311dd5c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db132-5f4e-77fb-a741-b5df4317ef31.webp",
      "image_media": {
        "alt_text": "Interior view of a well-equipped apartment fitness center with treadmills, weight machines, dumbbells, and mirrors.",
        "public_id": "019db132-5f4e-77fb-a741-b5df4317ef31",
        "storage_key": "property/6767906449165614/019db132-5f4e-77fb-a741-b5df4317ef31.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Interior view of a well-equipped apartment fitness center with treadmills, weight machines, dumbbells, and mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fd95ec50-2801-4069-9500-6182d99fac2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db132-5f80-7099-8fde-1ef5ebd95fa2.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with a stone fireplace, comfortable seating, and large windows.",
        "public_id": "019db132-5f80-7099-8fde-1ef5ebd95fa2",
        "storage_key": "property/6767906449165614/019db132-5f80-7099-8fde-1ef5ebd95fa2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy stone fireplace and ample seating for socializing or quiet relaxation.",
      "link": "",
      "alt_text": "Spacious community lounge with a stone fireplace, comfortable seating, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d562a85-3481-4520-a68a-2149f9b89757",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db132-5cac-727c-9b81-6154c287460e.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and weight machines.",
        "public_id": "019db132-5cac-727c-9b81-6154c287460e",
        "storage_key": "property/6767906449165614/019db132-5cac-727c-9b81-6154c287460e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, an elliptical, and a full range of weight machines.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5e115234-f866-41f3-95b4-b90e5a8ebdcc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db132-5e1f-777c-ae7a-46b92990de01.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with balconies and green lawn.",
        "public_id": "019db132-5e1f-777c-ae7a-46b92990de01",
        "storage_key": "property/6767906449165614/019db132-5e1f-777c-ae7a-46b92990de01.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of the apartment buildings showcasing balconies, windows, and manicured lawns.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with balconies and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_571f67f6-e24f-4176-8f54-0328aeb21147",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db132-5f18-7793-915e-2840230a82b8.webp",
      "image_media": {
        "alt_text": "Lounge area with a stone fireplace, comfortable seating, and large windows.",
        "public_id": "019db132-5f18-7793-915e-2840230a82b8",
        "storage_key": "property/6767906449165614/019db132-5f18-7793-915e-2840230a82b8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious lounge, featuring a cozy stone fireplace and ample seating. Large windows offer plenty of natural light.",
      "link": "",
      "alt_text": "Lounge area with a stone fireplace, comfortable seating, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a6abf0d-3987-4d23-8f20-1416cb1bc74e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db132-5bf8-73ed-a8d1-8d65b8870c3a.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with balconies, green lawn, picnic table, and grill.",
        "public_id": "019db132-5bf8-73ed-a8d1-8d65b8870c3a",
        "storage_key": "property/6767906449165614/019db132-5bf8-73ed-a8d1-8d65b8870c3a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of the apartment complex showcasing the building's architecture, balconies, and surrounding green spaces with amenities like a picnic table and grill.",
      "link": "",
      "alt_text": "Apartment building exterior with balconies, green lawn, picnic table, and grill.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9ad8b427-a05b-4ed7-89ad-a16b6f2a9fd2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db132-5b70-77ee-9e94-2d3a8c6eebd6.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot in foreground.",
        "public_id": "019db132-5b70-77ee-9e94-2d3a8c6eebd6",
        "storage_key": "property/6767906449165614/019db132-5b70-77ee-9e94-2d3a8c6eebd6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of modern apartment buildings featuring brick accents and balconies, with a spacious parking lot.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with parking lot in foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_61ef2bea-2aeb-4451-9e01-04b86088fa3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db132-24d7-729c-9f2c-a681c3aded07.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with garages and parking lot.",
        "public_id": "019db132-24d7-729c-9f2c-a681c3aded07",
        "storage_key": "property/6767906449165614/019db132-24d7-729c-9f2c-a681c3aded07.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of an apartment building featuring brick and siding, with multiple garages and a paved parking lot under a blue sky.",
      "link": "",
      "alt_text": "Apartment building exterior with garages and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_181a43f6-0ab4-40d3-a8d4-69884ed29778",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db132-20bd-7702-b5aa-3117c004724f.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019db132-20bd-7702-b5aa-3117c004724f",
        "storage_key": "property/6767906449165614/019db132-20bd-7702-b5aa-3117c004724f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings set against a clear blue sky with fluffy clouds. The property features well-kept lawns and modern architecture.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3b1b74ea-d661-4ac3-b47c-6b2ba56d31c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-f716-761f-8d74-c4bbd32aeb55.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with multiple garages.",
        "public_id": "019db131-f716-761f-8d74-c4bbd32aeb55",
        "storage_key": "property/6767906449165614/019db131-f716-761f-8d74-c4bbd32aeb55.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior of an apartment building featuring a row of garages and residential units above.",
      "link": "",
      "alt_text": "Apartment building exterior with multiple garages.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f18ccd45-38d0-4d42-99d3-60c874e8d9bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-eb48-7327-a1cf-4a846a7ed78c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white tub, toilet, and wooden vanity.",
        "public_id": "019db131-eb48-7327-a1cf-4a846a7ed78c",
        "storage_key": "property/6767906449165614/019db131-eb48-7327-a1cf-4a846a7ed78c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a clean white tub and toilet, complemented by a stylish wooden vanity and decorative wall tiles above the sink. A large mirror and lush plant add to the ambiance.",
      "link": "",
      "alt_text": "Modern bathroom with a white tub, toilet, and wooden vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3107ac4b-8629-4062-9b2c-b50d59305c6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-f2f1-775c-b448-3f4f37971bcd.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and two baskets",
        "public_id": "019db131-f2f1-775c-b448-3f4f37971bcd",
        "storage_key": "property/6767906449165614/019db131-f2f1-775c-b448-3f4f37971bcd.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and soft carpeting, ready for your personal touch.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and two baskets",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aecebe01-f58a-4760-94d6-5b72cff1b849",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-ce6a-75cd-bd0b-b6187d5956c9.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and three woven baskets on the floor.",
        "public_id": "019db131-ce6a-75cd-bd0b-b6187d5956c9",
        "storage_key": "property/6767906449165614/019db131-ce6a-75cd-bd0b-b6187d5956c9.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and storage baskets, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and three woven baskets on the floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c4e1db2c-f32d-4339-96ae-ef17ffd0072f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-7f96-7168-92af-d386dc3b3b0e.webp",
      "image_media": {
        "alt_text": "Cozy living room with a fireplace, TV, and comfortable seating.",
        "public_id": "019db131-7f96-7168-92af-d386dc3b3b0e",
        "storage_key": "property/6767906449165614/019db131-7f96-7168-92af-d386dc3b3b0e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy this inviting living room featuring a warm fireplace, a large television, and plush seating, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Cozy living room with a fireplace, TV, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c9cb91ff-ceb0-4278-8f21-c3bf4d93af99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-761e-745f-bd4d-141afac54949.webp",
      "image_media": {
        "alt_text": "Queen-size bed with plush bedding and decorative pillows, dresser with mirror, nightstand, and ceiling fan.",
        "public_id": "019db131-761e-745f-bd4d-141afac54949",
        "storage_key": "property/6767906449165614/019db131-761e-745f-bd4d-141afac54949.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, elegant dresser with mirror, and a functional nightstand, perfect for relaxation.",
      "link": "",
      "alt_text": "Queen-size bed with plush bedding and decorative pillows, dresser with mirror, nightstand, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_413f7c32-cfa4-457d-8837-c4e7bafe9429",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-73b5-7490-866a-fe784ed477fb.webp",
      "image_media": {
        "alt_text": "Home office area with a desk, chair, and window views.",
        "public_id": "019db131-73b5-7490-866a-fe784ed477fb",
        "storage_key": "property/6767906449165614/019db131-73b5-7490-866a-fe784ed477fb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this bright home office, featuring a stylish desk and comfortable seating.",
      "link": "",
      "alt_text": "Home office area with a desk, chair, and window views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6b57f639-2385-4635-a542-fd88612f10d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-70b1-704c-a4a4-d457e25ce261.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs, and a desk area with a chair.",
        "public_id": "019db131-70b1-704c-a4a4-d457e25ce261",
        "storage_key": "property/6767906449165614/019db131-70b1-704c-a4a4-d457e25ce261.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Dine in style or get some work done in this versatile dining and desk area.",
      "link": "",
      "alt_text": "Dining area with a table and chairs, and a desk area with a chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0088000a-35d0-4162-8608-2dc2e88997c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-6ac5-756f-903d-dd22342b026a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white appliances, wooden cabinets, and a granite countertop.",
        "public_id": "019db131-6ac5-756f-903d-dd22342b026a",
        "storage_key": "property/6767906449165614/019db131-6ac5-756f-903d-dd22342b026a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Discover a beautifully designed kitchen featuring sleek white appliances, ample wooden cabinetry, and a durable granite countertop, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white appliances, wooden cabinets, and a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7dc50e5b-055c-4e03-91e7-01d5c085175c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-6369-708f-aff7-e8249be2769c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, granite countertops, and white appliances.",
        "public_id": "019db131-6369-708f-aff7-e8249be2769c",
        "storage_key": "property/6767906449165614/019db131-6369-708f-aff7-e8249be2769c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample cabinet space, a breakfast bar, and modern appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with wood cabinets, granite countertops, and white appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d739dad-cbf0-4c88-99a9-4c9354aaddf9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-69b5-722f-a25d-69728c199dfb.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white microwave and stove, and granite countertops.",
        "public_id": "019db131-69b5-722f-a25d-69728c199dfb",
        "storage_key": "property/6767906449165614/019db131-69b5-722f-a25d-69728c199dfb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample cabinet space, modern appliances, and granite countertops for a comfortable and functional living experience.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, white microwave and stove, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a5645cad-d78c-4b3e-8fa0-dd17e6a3e69b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-62a0-7473-86dc-ac59efc93a2a.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, sofa, coffee table, and dining area.",
        "public_id": "019db131-62a0-7473-86dc-ac59efc93a2a",
        "storage_key": "property/6767906449165614/019db131-62a0-7473-86dc-ac59efc93a2a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace, comfortable sofa, elegant coffee table, and a dedicated dining space. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace, sofa, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b5701c50-7046-455c-8e5a-7e6a9755aadc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-6432-757d-a487-8be7ec22ae9f.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and view of the kitchen.",
        "public_id": "019db131-6432-757d-a487-8be7ec22ae9f",
        "storage_key": "property/6767906449165614/019db131-6432-757d-a487-8be7ec22ae9f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa and modern coffee table, seamlessly opening to a well-equipped kitchen with breakfast bar seating.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, and view of the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ac616fcf-1383-4475-8a69-bd6ba4510f03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-4cd6-7598-ab37-090cd995cff4.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, bathtub, vanity, and mirror",
        "public_id": "019db131-4cd6-7598-ab37-090cd995cff4",
        "storage_key": "property/6767906449165614/019db131-4cd6-7598-ab37-090cd995cff4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a toilet, bathtub with a white shower curtain, and a spacious vanity with ample storage. The neutral color palette creates a relaxing atmosphere.",
      "link": "",
      "alt_text": "Bathroom with toilet, bathtub, vanity, and mirror",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39e00c0c-92c3-419f-8ff7-fde3c76e181b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-442d-729d-95e9-4b80c6edd3b7.webp",
      "image_media": {
        "alt_text": "Balcony overlooking a parking lot with trees and a blue sky.",
        "public_id": "019db131-442d-729d-95e9-4b80c6edd3b7",
        "storage_key": "property/6767906449165614/019db131-442d-729d-95e9-4b80c6edd3b7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening breeze on this private balcony, offering a peaceful view of the surrounding trees and parking area.",
      "link": "",
      "alt_text": "Balcony overlooking a parking lot with trees and a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb9786a8-683c-4897-89bd-db772612112b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db130-b035-7404-83c2-b81c7e97ad20.webp",
      "image_media": {
        "alt_text": "View of a sparkling swimming pool with lounge chairs and umbrellas, surrounded by lush landscaping and apartment buildings under a clear blue sky.",
        "public_id": "019db130-b035-7404-83c2-b81c7e97ad20",
        "storage_key": "property/6767906449165614/019db130-b035-7404-83c2-b81c7e97ad20.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our beautiful outdoor pool, perfect for relaxing and soaking up the sun. The surrounding grounds offer ample space to unwind.",
      "link": "",
      "alt_text": "View of a sparkling swimming pool with lounge chairs and umbrellas, surrounded by lush landscaping and apartment buildings under a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8aa00807-39aa-402e-9df8-10f95d61fb0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db130-af61-747a-9e68-eac66bed58cf.webp",
      "image_media": {
        "alt_text": "A spacious U-shaped kitchen with wood cabinets, white appliances, and granite countertops.",
        "public_id": "019db130-af61-747a-9e68-eac66bed58cf",
        "storage_key": "property/6767906449165614/019db130-af61-747a-9e68-eac66bed58cf.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Upgrade your culinary experience in this beautifully designed U-shaped kitchen, complete with ample cabinet space, modern white appliances, and elegant granite countertops.",
      "link": "",
      "alt_text": "A spacious U-shaped kitchen with wood cabinets, white appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1e7be006-df6d-43ff-aadb-226068cd61b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db130-a347-72ed-82ad-8988161d2bd4.webp",
      "image_media": {
        "alt_text": "Living room and dining area with sofa, armchair, coffee table, and dining set.",
        "public_id": "019db130-a347-72ed-82ad-8988161d2bd4",
        "storage_key": "property/6767906449165614/019db130-a347-72ed-82ad-8988161d2bd4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this spacious apartment, featuring a well-appointed living area and a dedicated dining space perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with sofa, armchair, coffee table, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a1d192ae-7e8e-4344-a85a-5cc975012417",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db130-afcd-744f-83cf-99d2c3de756d.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs, a floor lamp, and artwork on the wall.",
        "public_id": "019db130-afcd-744f-83cf-99d2c3de756d",
        "storage_key": "property/6767906449165614/019db130-afcd-744f-83cf-99d2c3de756d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals in this inviting dining area, featuring a stylish round table, comfortable seating, and elegant decor.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs, a floor lamp, and artwork on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b7480906-0355-4c3e-8057-bfc6ce678ad4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db130-78ac-743c-90e0-6c365ffa8637.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with picnic table, umbrella, and built-in stone grill station.",
        "public_id": "019db130-78ac-743c-90e0-6c365ffa8637",
        "storage_key": "property/6767906449165614/019db130-78ac-743c-90e0-6c365ffa8637.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community's picnic area, complete with comfortable seating and a stone-built grill station for gatherings.",
      "link": "",
      "alt_text": "Outdoor seating area with picnic table, umbrella, and built-in stone grill station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_94766248-abb4-449a-af70-f9578c5b8723",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db130-6f9c-7291-b070-712399e6d644.webp",
      "image_media": {
        "alt_text": "Property entrance with signage and landscaping.",
        "public_id": "019db130-6f9c-7291-b070-712399e6d644",
        "storage_key": "property/6767906449165614/019db130-6f9c-7291-b070-712399e6d644.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of the property entrance, showcasing the building facade, landscaping, and signage.",
      "link": "",
      "alt_text": "Property entrance with signage and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8795ee48-aab3-4682-9c1a-5d04d8629609",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db130-6019-71df-8fb2-6185333cd183.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019db130-6019-71df-8fb2-6185333cd183",
        "storage_key": "property/6767906449165614/019db130-6019-71df-8fb2-6185333cd183.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing on sunny days.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_755362c9-f407-4f90-9fcb-f5e2a2999989",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db130-7079-730d-afcc-3cce34a625aa.webp",
      "image_media": {
        "alt_text": "Apartment complex with a large, bright blue swimming pool and lounge chairs.",
        "public_id": "019db130-7079-730d-afcc-3cce34a625aa",
        "storage_key": "property/6767906449165614/019db130-7079-730d-afcc-3cce34a625aa.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Your perfect oasis awaits.",
      "link": "",
      "alt_text": "Apartment complex with a large, bright blue swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_46b52ab0-3872-4b1b-8e20-dfc1ed402404",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db130-61a3-7786-8131-581758aeea27.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily property building with stone accents and a manicured lawn.",
        "public_id": "019db130-61a3-7786-8131-581758aeea27",
        "storage_key": "property/6767906449165614/019db130-61a3-7786-8131-581758aeea27.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "A beautiful multifamily property exterior featuring stone accents, a well-maintained lawn, and lush landscaping, creating an inviting atmosphere.",
      "link": "",
      "alt_text": "Exterior view of a multifamily property building with stone accents and a manicured lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6a552082-f48b-4f6e-ac77-7a5ca049890f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db130-7005-75db-b8e7-e8b479d3f7dc.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019db130-7005-75db-b8e7-e8b479d3f7dc",
        "storage_key": "property/6767906449165614/019db130-7005-75db-b8e7-e8b479d3f7dc.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Dive into relaxation at our stunning resort-style swimming pool, complete with comfortable lounge chairs and surrounded by beautiful apartment buildings. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aa8963a0-9dd2-4875-9257-fc298e64976a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019e1743-6081-76a9-a4e7-e86e243d0ca8.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a queen-sized bed, nightstand with lamp, and a dresser.",
        "public_id": "019e1743-6081-76a9-a4e7-e86e243d0ca8",
        "storage_key": "property/6767906449165614/019e1743-6081-76a9-a4e7-e86e243d0ca8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy and well-lit bedroom featuring a comfortable queen-sized bed, stylish nightstand with a lamp, and ample storage space.",
      "link": "",
      "alt_text": "A staged bedroom with a queen-sized bed, nightstand with lamp, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a908d9a3-82c6-4418-ac51-b165ab2b29ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019e1743-24fd-70b7-8a21-f770d647c9c1.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a sofa, armchair, coffee table, and bar seating.",
        "public_id": "019e1743-24fd-70b7-8a21-f770d647c9c1",
        "storage_key": "property/6767906449165614/019e1743-24fd-70b7-8a21-f770d647c9c1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly connected to the kitchen, featuring comfortable seating and a breakfast bar. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area with a sofa, armchair, coffee table, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a84e8c95-5548-4636-b0ee-357ba98bfa24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019e1743-391b-70ab-80bc-d54f3fd2b9c4.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with neutral decor, featuring a leather armchair, sofa, TV, and dining bar.",
        "public_id": "019e1743-391b-70ab-80bc-d54f3fd2b9c4",
        "storage_key": "property/6767906449165614/019e1743-391b-70ab-80bc-d54f3fd2b9c4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy spacious living areas and a modern kitchen, perfect for relaxing and entertaining. This apartment offers a comfortable and stylish atmosphere.",
      "link": "",
      "alt_text": "Living room and kitchen area with neutral decor, featuring a leather armchair, sofa, TV, and dining bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e02c66da-eaf1-4efe-a18c-05a529a0cf5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019e1743-320f-7273-ab0e-91f797d40603.webp",
      "image_media": {
        "alt_text": "Home office desk and chair with artwork on the wall. View into a bathroom.",
        "public_id": "019e1743-320f-7273-ab0e-91f797d40603",
        "storage_key": "property/6767906449165614/019e1743-320f-7273-ab0e-91f797d40603.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this apartment. This stylish desk and chair combination is perfect for a home office, with a glimpse into a well-appointed bathroom.",
      "link": "",
      "alt_text": "Home office desk and chair with artwork on the wall. View into a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bbe9fa45-3b7c-4f47-ad6b-52c9a5169b7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019e1743-3272-71cc-8c6b-19b395424135.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs, large windows with blinds, and a potted plant.",
        "public_id": "019e1743-3272-71cc-8c6b-19b395424135",
        "storage_key": "property/6767906449165614/019e1743-3272-71cc-8c6b-19b395424135.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your meals in this bright and airy dining space, perfect for intimate dinners or lively gatherings. Features large windows for ample natural light.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs, large windows with blinds, and a potted plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_42220641-ab5c-44a8-9e81-22a2fa87fc34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019e1743-2bac-7374-ad5f-ada6c3d95a8d.webp",
      "image_media": {
        "alt_text": "Spacious living room with a large sectional sofa, accent chair, coffee table, dining table, and large windows.",
        "public_id": "019e1743-2bac-7374-ad5f-ada6c3d95a8d",
        "storage_key": "property/6767906449165614/019e1743-2bac-7374-ad5f-ada6c3d95a8d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy ample natural light and open-concept living in this beautifully appointed apartment living and dining area, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Spacious living room with a large sectional sofa, accent chair, coffee table, dining table, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9797037d-e272-4e73-920a-8116b8580a3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019e1743-22c6-7037-bd74-e3f2ab050c57.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and a small table, overlooking trees and a parking lot.",
        "public_id": "019e1743-22c6-7037-bd74-e3f2ab050c57",
        "storage_key": "property/6767906449165614/019e1743-22c6-7037-bd74-e3f2ab050c57.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, complete with seating for two.",
      "link": "",
      "alt_text": "Balcony with two chairs and a small table, overlooking trees and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ba50b414-e266-431f-8c71-2ae0da12a9fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019e1742-e7b3-77e8-9e9d-74b25ef2d237.webp",
      "image_media": {
        "alt_text": "Modern kitchen with cherry wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019e1742-e7b3-77e8-9e9d-74b25ef2d237",
        "storage_key": "property/6767906449165614/019e1742-e7b3-77e8-9e9d-74b25ef2d237.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring cherry wood cabinets, sleek granite countertops, and a full suite of stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with cherry wood cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0f92cf2d-6b7d-49f0-8383-f6f3544fbb22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019e1742-75a9-7469-bdf6-f94b3c1a7ff5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel refrigerator, microwave, oven, and granite countertops.",
        "public_id": "019e1742-75a9-7469-bdf6-f94b3c1a7ff5",
        "storage_key": "property/6767906449165614/019e1742-75a9-7469-bdf6-f94b3c1a7ff5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and elegant granite countertops, perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel refrigerator, microwave, oven, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e09fc3c9-af95-400c-9f18-49e0e8303f12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "8204 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-3aba-707a-908d-2cbea4da3177.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3aba-707a-908d-2cbea4da3177",
        "storage_key": "property/6767906449165614/019d2709-3aba-707a-908d-2cbea4da3177.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-s-olympia-ave?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10653753003214397634&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0450715",
      "poi_longitude": "-96.005574",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-445-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6d0c-74eb-8eb0-ae6920004539.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6d0c-74eb-8eb0-ae6920004539",
        "storage_key": "property/6767906449165614/019d2709-6d0c-74eb-8eb0-ae6920004539.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWgROD6UtocRwmBYEem72ZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_333be050-cc3e-45a9-a2d6-31a174db0cdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "3647 S Peoria Ave, Tulsa, OK 74105, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-3991-75ea-b596-2dee5a5ba42e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3991-75ea-b596-2dee5a5ba42e",
        "storage_key": "property/6767906449165614/019d2709-3991-75ea-b596-2dee5a5ba42e.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/3647-south-peoria-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=2628044797258492093&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.11008330000001",
      "poi_longitude": "-95.9749998",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-879-1921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6d0c-74eb-8eb0-ae6920004539.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6d0c-74eb-8eb0-ae6920004539",
        "storage_key": "property/6767906449165614/019d2709-6d0c-74eb-8eb0-ae6920004539.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30WgIlWTtocRvehnstGweCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_978b4bc8-b6f5-4667-bb91-12b50db3c156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Neighborhood JAM",
      "poi_type": "Restaurants",
      "poi_address": "4830 E 61st St #300, Tulsa, OK 74136, USA",
      "poi_short_description": "Relaxed restaurant at the Shops at Warren Place attracting diners for breakfast, brunch, and lunch.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-393d-7739-92c6-67407d6445f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-393d-7739-92c6-67407d6445f0",
        "storage_key": "property/6767906449165614/019d2709-393d-7739-92c6-67407d6445f0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thatsmyjamok.com/locations/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10095226965287487523&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "neighborhood-jam",
      "poi_latitude": "36.0743128",
      "poi_longitude": "-95.922983",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-508-7744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6d0c-74eb-8eb0-ae6920004539.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6d0c-74eb-8eb0-ae6920004539",
        "storage_key": "property/6767906449165614/019d2709-6d0c-74eb-8eb0-ae6920004539.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK2Z2CQ6TtocRI8jnKHBzGYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_56cc3781-f796-49b6-8d93-eec9fcca6da4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Restaurants",
      "poi_address": "6008 S 49th W Ave, Tulsa, OK 74107, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-3956-7209-aee2-6438577d88a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3956-7209-aee2-6438577d88a9",
        "storage_key": "property/6767906449165614/019d2709-3956-7209-aee2-6438577d88a9.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ok/tulsa/6008-s-49th-w-ave?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDM3ODQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=18199062979716793914&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "36.0765783",
      "poi_longitude": "-96.0483269",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-446-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6d0c-74eb-8eb0-ae6920004539.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6d0c-74eb-8eb0-ae6920004539",
        "storage_key": "property/6767906449165614/019d2709-6d0c-74eb-8eb0-ae6920004539.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB28t6XKVtocROkb7dlsPkPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_d279f4a9-9201-49b2-bdf2-9e1192f2c676",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Tulsa Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 E Outlet Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Clean outdoor mall offering discounts on designer wares and home goods, plus a playground.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores with great deals and a convenient layout. They highlight the clean, spacious, and welcoming atmosphere, as well as the comfortable shoes and delicious cookies. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-3dd8-73f8-80b7-b29e41310978.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3dd8-73f8-80b7-b29e41310978",
        "storage_key": "property/6767906449165614/019d2709-3dd8-73f8-80b7-b29e41310978.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542502898214519848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-premium-outlets",
      "poi_latitude": "36.0147952",
      "poi_longitude": "-95.962744",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-528-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6d0f-73be-9b3f-ea495e801cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6d0f-73be-9b3f-ea495e801cbe",
        "storage_key": "property/6767906449165614/019d2709-6d0f-73be-9b3f-ea495e801cbe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi_O0gRORtocRKERWF3F9c_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_18d06e1b-4f6e-4e92-88b4-0a3e475363f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "3702 S Peoria Ave, Tulsa, OK 74105, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a unique selection of high-quality products, including fresh flowers, frozen meals, and ethnic foods. They highlight the reasonable prices, especially for produce, and the fun, upbeat vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-3da8-71ce-8d3a-26d41ee96550.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3da8-71ce-8d3a-26d41ee96550",
        "storage_key": "property/6767906449165614/019d2709-3da8-71ce-8d3a-26d41ee96550.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/tulsa/460/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13583892652892204013&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "36.1096067",
      "poi_longitude": "-95.975934",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-712-9768",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6d17-7456-a227-149e07ae1d92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6d17-7456-a227-149e07ae1d92",
        "storage_key": "property/6767906449165614/019d2709-6d17-7456-a227-149e07ae1d92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TxY2lOTtocR7autsmWug7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d71ba133-3ea3-4d78-ad69-4d28dcdf48f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Tulsa Hills Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7380 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Mid-range chain stores & specialty shops, plus familiar fast food, in a refined strip-mall format.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including retail, food, and services, and has convenient parking. They highlight the easy access, convenient location, and the ability to find everything in one place. They also like the clean and safe environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-3e38-7758-94aa-3863b1a066b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3e38-7758-94aa-3863b1a066b9",
        "storage_key": "property/6767906449165614/019d2709-3e38-7758-94aa-3863b1a066b9.webp",
        "width": 1280,
        "height": 1027
      },
      "poi_business_url": "http://www.shoptulsahills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185409236621719808&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-hills-shopping-center",
      "poi_latitude": "36.0563227",
      "poi_longitude": "-96.0033215",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 214-979-3334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6d0f-73be-9b3f-ea495e801cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6d0f-73be-9b3f-ea495e801cbe",
        "storage_key": "property/6767906449165614/019d2709-6d0f-73be-9b3f-ea495e801cbe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5R7A_GeUtocRAPl5hIaPFTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_835350f3-7ed9-4d66-a48c-0d7bfbda6ec5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1401 E 41st St, Tulsa, OK 74105, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, specialty items, and pre-made meals. They also highlight the clean and well-stocked store, and the friendly and helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-3f2c-718f-89ab-59133350d476.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3f2c-718f-89ab-59133350d476",
        "storage_key": "property/6767906449165614/019d2709-3f2c-718f-89ab-59133350d476.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/brookside?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=14383884403839006292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.104878",
      "poi_longitude": "-95.9732615",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-712-7555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6d17-7456-a227-149e07ae1d92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6d17-7456-a227-149e07ae1d92",
        "storage_key": "property/6767906449165614/019d2709-6d17-7456-a227-149e07ae1d92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk5_NEVCTtocRVPYa_afSncc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_231b57d6-15ad-4550-92dd-de3ecfc5432a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-4260-7552-b670-e02ca1f43843.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4260-7552-b670-e02ca1f43843",
        "storage_key": "property/6767906449165614/019d2709-4260-7552-b670-e02ca1f43843.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6d17-7456-a227-1829d9f3a87e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6d17-7456-a227-1829d9f3a87e",
        "storage_key": "property/6767906449165614/019d2709-6d17-7456-a227-1829d9f3a87e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e9522ec0-d099-4401-a4f9-ce8d57437307",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Tulsa Community College West Campus",
      "poi_type": "Education",
      "poi_address": "7505 W 41st St, Tulsa, OK 74107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-428a-74fa-b756-2e5ef44c35e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-428a-74fa-b756-2e5ef44c35e5",
        "storage_key": "property/6767906449165614/019d2709-428a-74fa-b756-2e5ef44c35e5.webp",
        "width": 1275,
        "height": 1280
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5528324813803040548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-west-campus",
      "poi_latitude": "36.1071167",
      "poi_longitude": "-96.0768177",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6d17-7456-a227-1829d9f3a87e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6d17-7456-a227-1829d9f3a87e",
        "storage_key": "property/6767906449165614/019d2709-6d17-7456-a227-1829d9f3a87e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl_zJWKWStocRJC-1uSCOuEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_cfdb7a87-afb2-4daf-8ce8-0f53065a312b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-43cc-73a8-92ba-dbf69d628bdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-43cc-73a8-92ba-dbf69d628bdb",
        "storage_key": "property/6767906449165614/019d2709-43cc-73a8-92ba-dbf69d628bdb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=247462858016865972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-tulsa",
      "poi_latitude": "36.1024131",
      "poi_longitude": "-95.9259796",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-660-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6d17-7456-a227-1829d9f3a87e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6d17-7456-a227-1829d9f3a87e",
        "storage_key": "property/6767906449165614/019d2709-6d17-7456-a227-1829d9f3a87e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8INcGStocRtL4ygygqbwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6ab703f8-4340-4538-904b-37781deda5a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Thousands of aquatic species, plus a walk-through tunnel & chances to touch sharks & stingrays.",
      "poi_long_description": "People say this aquarium offers a wide variety of fish, including sharks, jellyfish, and an octopus, as well as interactive exhibits and touch tanks. They highlight the family-friendly atmosphere, the fun and educational experience, and the impressive shark tunnel and sea turtle exhibit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-442d-74fc-8f6e-7ac9defeff30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-442d-74fc-8f6e-7ac9defeff30",
        "storage_key": "property/6767906449165614/019d2709-442d-74fc-8f6e-7ac9defeff30.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_9b91e4fb-bb6e-43f3-994b-6ae27a3b05ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Philbrook Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2727 S Rockford Rd, Tulsa, OK 74114, USA",
      "poi_short_description": "Global collection of fine & decorative art in an ornate Italian Renaissance-style mansion & gardens.",
      "poi_long_description": "People say this museum offers a diverse collection of art, including European and Native American works, and a beautiful Samurai exhibit. They highlight the stunning gardens, the tranquil and relaxing atmosphere, and the well-maintained grounds. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-4751-711d-9ae5-fc7a2f9c627b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4751-711d-9ae5-fc7a2f9c627b",
        "storage_key": "property/6767906449165614/019d2709-4751-711d-9ae5-fc7a2f9c627b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.philbrook.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1301074669923315730&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "philbrook-museum-of-art",
      "poi_latitude": "36.1238549",
      "poi_longitude": "-95.9700944",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-749-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-7125-75f8-80e4-50d785447afb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7125-75f8-80e4-50d785447afb",
        "storage_key": "property/6767906449165614/019d2709-7125-75f8-80e4-50d785447afb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VsvX7DstocRErAJ14RYDhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_96196733-43a4-4459-989c-253fac58a767",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Discovery Lab",
      "poi_type": "Entertainment",
      "poi_address": "3123 Riverside Dr, Tulsa, OK 74105, USA",
      "poi_short_description": "Interactive kids' science museum & play center offering educational exhibits & DIY crafts.",
      "poi_long_description": "People say this children's museum offers a wide variety of interactive and educational exhibits, including a ball space, maker spaces, and a paper airplane section. They highlight the fun, hands-on learning experience, and the value of a membership for frequent visits. They also like the friendly and courteous staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-474c-7234-84ac-6d3c3a91bb69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-474c-7234-84ac-6d3c3a91bb69",
        "storage_key": "property/6767906449165614/019d2709-474c-7234-84ac-6d3c3a91bb69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://discoverylab.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13384989011052284106&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "discovery-lab",
      "poi_latitude": "36.1180586",
      "poi_longitude": "-95.9841454",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-295-8144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-7125-75f8-80e4-50d785447afb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7125-75f8-80e4-50d785447afb",
        "storage_key": "property/6767906449165614/019d2709-7125-75f8-80e4-50d785447afb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJi01Lj3vrtocRykhHvpYIwbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f84c2baf-6e38-4e76-8f82-ec5ef068a8d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_long_description": "People say this arena offers comfortable seating and good views for events, including concerts and sporting events. They highlight the venue is clean, family-friendly, and has plenty of parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-48dd-725e-8469-eebf77032268.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-48dd-725e-8469-eebf77032268",
        "storage_key": "property/6767906449165614/019d2709-48dd-725e-8469-eebf77032268.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_a6cbc1ee-5ed5-4e2e-9e7e-b190ece178ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, zip lines, and virtual reality. They also highlight the helpful staff and the fun atmosphere for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-4a3a-71c9-868d-0ca4b79dcbcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4a3a-71c9-868d-0ca4b79dcbcc",
        "storage_key": "property/6767906449165614/019d2709-4a3a-71c9-868d-0ca4b79dcbcc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_3e1dbf1e-6638-47cc-a890-49787433c497",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1331 E 71st St, Tulsa, OK 74136, USA",
      "poi_short_description": "Chain gym offering a variety of fitness equipment, with tanning, and massage options, plus 24/7 access.",
      "poi_long_description": "People say this gym offers a wide variety of updated equipment, including hydromassage beds, and tanning services. They highlight the affordable price, clean facilities, and ample machines that prevent overcrowding. They also like the friendly and helpful staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-4c6f-76f0-bdea-106b284a4732.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4c6f-76f0-bdea-106b284a4732",
        "storage_key": "property/6767906449165614/019d2709-4c6f-76f0-bdea-106b284a4732.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/tulsa-riverside-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13693593335410364020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0614737",
      "poi_longitude": "-95.9748504",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 539-525-9151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDx_GDIWTtocRdI7KN5ZqCb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_aca33d61-6f6a-4386-9129-402fb7b6722a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Oklahoma Veterinary Specialists",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 West 78th Street South, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-4bd2-71ac-b847-c3d2327f330e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4bd2-71ac-b847-c3d2327f330e",
        "storage_key": "property/6767906449165614/019d2709-4bd2-71ac-b847-c3d2327f330e.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "http://okvets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5093478136724344104&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-veterinary-specialists",
      "poi_latitude": "36.0519175",
      "poi_longitude": "-96.0079484",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 918-299-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8o0AyeUtocRKE2sAmGrr0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_be55e9cd-9e0a-49e3-8815-9087c6139cac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "4818 E 80th St Ste A, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide selection of free weights, machines, and classes, and has amenities like tanning, massage beds, and a sauna. They highlight the clean and well-maintained facility, and the friendly and helpful staff. They also like the convenient 24-hour access and the welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-4e60-7201-b625-4012d0ad4f56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4e60-7201-b625-4012d0ad4f56",
        "storage_key": "property/6767906449165614/019d2709-4e60-7201-b625-4012d0ad4f56.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://10gym.com/south-tulsa-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2406416433432823692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.047648",
      "poi_longitude": "-95.9239656",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-494-3644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-ITWKKTtocRjAdtGP9OZSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fb657f48-ca9d-4a8e-aa6b-643f96e0aedb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Midtown Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "4103 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Clean gym featuring clean locker rooms and a workout café serving protein shakes and smoothie drinks.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, classes, and amenities, including a smoothie bar, steam room, and sauna. They highlight the clean facilities, spacious workout floor, and ample equipment even during peak times. They also like the friendly, welcoming, and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-4f36-76a3-8d86-da7f102b04a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4f36-76a3-8d86-da7f102b04a4",
        "storage_key": "property/6767906449165614/019d2709-4f36-76a3-8d86-da7f102b04a4.webp",
        "width": 619,
        "height": 348
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/midtown-tulsa.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9719539965655344511&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---midtown-tulsa",
      "poi_latitude": "36.1023537",
      "poi_longitude": "-95.9210055",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-641-5501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRwPcrceStocRf2UZORq-4oY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bfd28a55-9cf7-456c-afc7-92d481fd78ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Woodland West Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "9360 S Union Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-509b-71c9-bd39-6d216e69e642.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-509b-71c9-bd39-6d216e69e642",
        "storage_key": "property/6767906449165614/019d2709-509b-71c9-bd39-6d216e69e642.webp",
        "width": 956,
        "height": 960
      },
      "poi_business_url": "http://woodlandwestanimalhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13255369589477481966&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-west-animal-hospital",
      "poi_latitude": "36.0260526",
      "poi_longitude": "-96.0135411",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-299-1208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8o0AyeUtocR7h1SY2mI9Lc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_05ffe1f3-4ee7-4856-813a-69d66deeb98f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Health Zone at Saint Francis",
      "poi_type": "Health and Wellness",
      "poi_address": "5353 E 68th St, Tulsa, OK 74136, USA",
      "poi_short_description": "Clean fitness center with an exercise pool and friendly staff.",
      "poi_long_description": "People say this fitness center offers a wide variety of activities, including swimming, group exercise classes, and access to a gym with free weights and machines. They highlight the clean facilities, well-maintained equipment, and the availability of amenities such as saunas, a running track, and a cafe with healthy snacks and drinks. They also like the knowledgeable instructors and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-50d5-723c-8b2e-3a37d625419e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-50d5-723c-8b2e-3a37d625419e",
        "storage_key": "property/6767906449165614/019d2709-50d5-723c-8b2e-3a37d625419e.webp",
        "width": 350,
        "height": 350
      },
      "poi_business_url": "https://saintfrancis.com/health-zone/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9278000897024696176&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "health-zone-at-saint-francis",
      "poi_latitude": "36.0652247",
      "poi_longitude": "-95.9166471",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-494-1671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh5ZrRWaStocRcJ_prKgUwoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_d0b56246-9e79-4bd2-b435-84b4c27055c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Elephant In The Room Men's Grooming Lounge of Downtown Tulsa Men's Haircuts",
      "poi_type": "Health and Wellness",
      "poi_address": "1730 S Boston Ave suite a, Tulsa, OK 74119, USA",
      "poi_short_description": "Laid-back barbershop focusing on men's cuts, beard trims and paraffin hand treatments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-53a2-717a-95d2-72c407fa822b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-53a2-717a-95d2-72c407fa822b",
        "storage_key": "property/6767906449165614/019d2709-53a2-717a-95d2-72c407fa822b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://eitrlounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12678830938661803288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elephant-in-the-room-mens-grooming-lounge-of-downtown-tulsa-mens-haircuts",
      "poi_latitude": "36.1368371",
      "poi_longitude": "-95.9854917",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-877-2219",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfyMP9JTrtocRGFUrOpBB9K8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_58779ff1-430d-4ff5-b515-55d380fb0713",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Bebe Nails and Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "3346 S Peoria Ave, Tulsa, OK 74105, USA",
      "poi_short_description": "Manicures, pedicures, and other nail services are provided in this modern salon.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-53f5-76af-9d52-3e2a8f012ccd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-53f5-76af-9d52-3e2a8f012ccd",
        "storage_key": "property/6767906449165614/019d2709-53f5-76af-9d52-3e2a8f012ccd.webp",
        "width": 1280,
        "height": 487
      },
      "poi_business_url": "https://bebenailstulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8811069501955562628&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bebe-nails-and-spa",
      "poi_latitude": "36.1141392",
      "poi_longitude": "-95.9759051",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-551-7751",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKa1bMlOTtocRhNxWawc1R3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_39ed9385-8971-452d-a93a-8b53be3de7c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "South County Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "237 S Franklin St, Jenks, OK 74037, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-556b-774d-ae9e-81ede3cdf028.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-556b-774d-ae9e-81ede3cdf028",
        "storage_key": "property/6767906449165614/019d2709-556b-774d-ae9e-81ede3cdf028.webp",
        "width": 1074,
        "height": 422
      },
      "poi_business_url": "https://www.southcountysports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11480186237134042405&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "south-county-gymnastics",
      "poi_latitude": "36.0221056",
      "poi_longitude": "-96.0072134",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-740-1228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6d17-7456-a227-1829d9f3a87e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6d17-7456-a227-1829d9f3a87e",
        "storage_key": "property/6767906449165614/019d2709-6d17-7456-a227-1829d9f3a87e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt8_oiZ6WtocRJfWz247QUZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c4b54242-864d-4648-8856-43c49ad6336a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Milano Nail Bar",
      "poi_type": "Health and Wellness",
      "poi_address": "4925 E 71st St, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-551e-7631-90ae-66078f45fa6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-551e-7631-90ae-66078f45fa6e",
        "storage_key": "property/6767906449165614/019d2709-551e-7631-90ae-66078f45fa6e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://milanonailbarsouthtulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5277438856387453094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "milano-nail-bar",
      "poi_latitude": "36.0613058",
      "poi_longitude": "-95.9208704",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-492-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVUllEKStocRpmDRxq06PUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_733cd339-928e-4429-9a66-82a4b3d23d29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-596d-777f-b527-6d2afa516014.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-596d-777f-b527-6d2afa516014",
        "storage_key": "property/6767906449165614/019d2709-596d-777f-b527-6d2afa516014.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-7123-7658-9058-eb3742d6512f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7123-7658-9058-eb3742d6512f",
        "storage_key": "property/6767906449165614/019d2709-7123-7658-9058-eb3742d6512f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_1aa5ac14-bcfc-416b-acd6-2584a8d7da36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Saint Francis Children's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-5958-77e9-8eed-1ff4a8ba294f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5958-77e9-8eed-1ff4a8ba294f",
        "storage_key": "property/6767906449165614/019d2709-5958-77e9-8eed-1ff4a8ba294f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-children-s-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=1661235334016537986&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-childrens-hospital",
      "poi_latitude": "36.0735538",
      "poi_longitude": "-95.918465",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-502-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-7123-7658-9058-eb3742d6512f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7123-7658-9058-eb3742d6512f",
        "storage_key": "property/6767906449165614/019d2709-7123-7658-9058-eb3742d6512f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJWTCYDmCStocRghViFLzkDRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e029065f-8017-49df-ab43-52802da88f77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Woodward Park and Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2435 S Peoria Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "45 acres of horticultural gardens (rock, herb, rose & azalea), a Victorian conservatory & arboretum.",
      "poi_long_description": "People say this park offers beautiful scenery, well-maintained gardens, and a peaceful atmosphere. They highlight the opportunity to feed squirrels and the abundance of wildlife, including rabbits and birds. They also like the historical significance and architectural beauty of the mansion and conservatory.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-5b0d-7635-91b1-487ba1694a4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5b0d-7635-91b1-487ba1694a4a",
        "storage_key": "property/6767906449165614/019d2709-5b0d-7635-91b1-487ba1694a4a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.tulsagardencenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12962617171359971077&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodward-park-and-gardens",
      "poi_latitude": "36.1319247",
      "poi_longitude": "-95.9736606",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-576-5155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-7174-70d9-83f1-b8a941e145e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7174-70d9-83f1-b8a941e145e8",
        "storage_key": "property/6767906449165614/019d2709-7174-70d9-83f1-b8a941e145e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr8FnRKPstocRBTdKcqN35LM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_022b26de-9d9a-4b75-b798-6383d0e6e8e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Large city park with ample facilities including sports fields & courts, a pool, playgrounds & golf.",
      "poi_long_description": "Visitors say this park offers a golf course, playgrounds, and a walking trail, and they appreciate that it's family-friendly and well-maintained. They also highlight the beautiful scenery and the friendly and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-5baa-7479-8105-b1b06a9d9041.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5baa-7479-8105-b1b06a9d9041",
        "storage_key": "property/6767906449165614/019d2709-5baa-7479-8105-b1b06a9d9041.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-7174-70d9-83f1-b8a941e145e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7174-70d9-83f1-b8a941e145e8",
        "storage_key": "property/6767906449165614/019d2709-7174-70d9-83f1-b8a941e145e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c99816dc-9c0b-4597-a398-fb1d619a3807",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Large space featuring a dog park & small pond, plus trails for walking & biking.",
      "poi_long_description": "People say this park offers a variety of amenities, including playgrounds, trails, a dog park, a pond with fishing piers, and a disc golf course. They highlight the peaceful and serene vibe, and the well-maintained facilities. They also like the friendly atmosphere and the opportunities for outdoor recreation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-5ed5-744a-90be-38fea349619e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5ed5-744a-90be-38fea349619e",
        "storage_key": "property/6767906449165614/019d2709-5ed5-744a-90be-38fea349619e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-7174-70d9-83f1-b8a941e145e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7174-70d9-83f1-b8a941e145e8",
        "storage_key": "property/6767906449165614/019d2709-7174-70d9-83f1-b8a941e145e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_59b4f434-ace6-4f89-b692-744758e4ea58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Turkey Mountain",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6800 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Hilly, forested park featuring jogging, biking & horseback riding trails, plus restrooms.",
      "poi_long_description": "People say this park offers well-maintained trails suitable for hiking, biking, and running, with beautiful views of the city skyline and Arkansas River. They highlight the peaceful and refreshing atmosphere, perfect for connecting with nature and enjoying outdoor activities. They also like the new trail additions and upgrades, and the friendly community of fellow hikers and bikers. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-5f9c-7683-8857-95fd97182023.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5f9c-7683-8857-95fd97182023",
        "storage_key": "property/6767906449165614/019d2709-5f9c-7683-8857-95fd97182023.webp",
        "width": 576,
        "height": 1280
      },
      "poi_business_url": "https://www.riverparks.org/experience/turkey-mountain",
      "poi_directions_map_url": "https://maps.google.com/?cid=1129856788357496640&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "turkey-mountain",
      "poi_latitude": "36.0648571",
      "poi_longitude": "-95.9934169",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-596-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-7174-70d9-83f1-b8a941e145e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7174-70d9-83f1-b8a941e145e8",
        "storage_key": "property/6767906449165614/019d2709-7174-70d9-83f1-b8a941e145e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWFdbHyUtocRQL8cRcMOrg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7520fa09-954b-4b7a-9ce9-a03fae73cbfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "LaFortune Park Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5501 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Public golf course with an 18-hole championship course, par-3 course, driving range, and pro shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6009-76ff-a059-5d30cbc059c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6009-76ff-a059-5d30cbc059c5",
        "storage_key": "property/6767906449165614/019d2709-6009-76ff-a059-5d30cbc059c5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.lafortuneparkgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2854252431691340547&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park-golf-course",
      "poi_latitude": "36.082485",
      "poi_longitude": "-95.920632",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-496-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-74a3-734c-98e5-4e955437e2af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-74a3-734c-98e5-4e955437e2af",
        "storage_key": "property/6767906449165614/019d2709-74a3-734c-98e5-4e955437e2af.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJmUEN-vKStocRA9tB0nZXnCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_0e6331c4-8bc0-44cd-be24-edff3b2a8e66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Tulsa Riverside Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8605 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6006-77d8-a529-019efa195393.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6006-77d8-a529-019efa195393",
        "storage_key": "property/6767906449165614/019d2709-6006-77d8-a529-019efa195393.webp",
        "width": 1280,
        "height": 1034
      },
      "poi_business_url": "https://flytulsa.com/tulsa-river-side/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10887194896589047936&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-riverside-airport",
      "poi_latitude": "36.0378532",
      "poi_longitude": "-95.9909439",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-299-5886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-7507-716f-b669-06e9e928dfdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7507-716f-b669-06e9e928dfdd",
        "storage_key": "property/6767906449165614/019d2709-7507-716f-b669-06e9e928dfdd.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJG-5WQAiUtocRgMiiWxMWF5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_11a454da-878f-437b-bbc3-a05ec31baf91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Christiansen Aviation",
      "poi_type": "Transportation & Transit",
      "poi_address": "8767 Jack Bates Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-631f-75bf-8435-e3d08cb9c14c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-631f-75bf-8435-e3d08cb9c14c",
        "storage_key": "property/6767906449165614/019d2709-631f-75bf-8435-e3d08cb9c14c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://christiansenaviation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11204997232924193680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christiansen-aviation",
      "poi_latitude": "36.0365935",
      "poi_longitude": "-95.9895957",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-299-2646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-7507-716f-b669-06e9e928dfdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7507-716f-b669-06e9e928dfdd",
        "storage_key": "property/6767906449165614/019d2709-7507-716f-b669-06e9e928dfdd.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SWkpQWUtocRkHOu4Z0lgJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_79378e8d-2cc6-4f02-b7ce-d425b6218641",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-63a6-74b4-afc9-1e907d685920.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-63a6-74b4-afc9-1e907d685920",
        "storage_key": "property/6767906449165614/019d2709-63a6-74b4-afc9-1e907d685920.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f1122301-e645-4aa5-b72a-c11d952d2407",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Pepsi Main Truck Gate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5201-5325 S Lawton Ave, Tulsa, OK 74107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6499-771a-b191-7d2edab1a012.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6499-771a-b191-7d2edab1a012",
        "storage_key": "property/6767906449165614/019d2709-6499-771a-b191-7d2edab1a012.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4654779687138613676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pepsi-main-truck-gate",
      "poi_latitude": "36.0874451",
      "poi_longitude": "-95.9993929",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQbkIZSUtocRrNmZn3YZmUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_237e2464-442c-49bd-b1cb-59e338cf65e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Jenks Carepoint",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2914 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-64ff-7378-a5eb-83bd847bc9c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-64ff-7378-a5eb-83bd847bc9c5",
        "storage_key": "property/6767906449165614/019d2709-64ff-7378-a5eb-83bd847bc9c5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jenkscarepoint.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8342629785438649781&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jenks-carepoint",
      "poi_latitude": "36.0310709",
      "poi_longitude": "-95.9473523",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-600-2099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpx1KKjCNtocRtf2ptZb5xnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_086f0d7d-5f0f-42e0-a27a-ff2f3da4e890",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Jenks Community Food Bank",
      "poi_type": "Major Employers & Offices",
      "poi_address": "324 W Aquarium Pl, Jenks, OK 74037, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-6843-77a0-a3c1-f5d85d759265.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6843-77a0-a3c1-f5d85d759265",
        "storage_key": "property/6767906449165614/019d2709-6843-77a0-a3c1-f5d85d759265.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://jenksfoodbank.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11256631671942751398&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jenks-community-food-bank",
      "poi_latitude": "36.0212971",
      "poi_longitude": "-95.9729034",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-995-7117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ_UvRGuRtocRpiSPjd2WN5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_60171801-fc9d-4796-aeea-b77c3564e080",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "AAON R&D Lab / Norman Asbjornson Innovation Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2422 S Yukon Ave, Tulsa, OK 74107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-687c-7505-85ab-acda37be8783.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-687c-7505-85ab-acda37be8783",
        "storage_key": "property/6767906449165614/019d2709-687c-7505-85ab-acda37be8783.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6691178593674694652&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aaon-rd-lab--norman-asbjornson-innovation-center",
      "poi_latitude": "36.1292686",
      "poi_longitude": "-96.0198974",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-583-2266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-710a-7011-a48e-4f66445c6b2d",
        "storage_key": "property/6767906449165614/019d2709-710a-7011-a48e-4f66445c6b2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnxr45iPrtocR_I-txHrX21w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_56fe580c-ca9e-4039-80a9-345d927a163b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Jenks Northwest Elementary",
      "poi_type": "Education",
      "poi_address": "7625 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jenksps.org/o/northwest-elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=4425730907336280944&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-northwest-elementary",
      "poi_latitude": "36.0524412",
      "poi_longitude": "-95.9929499",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927b-7730-8202-ef2e49d060cc",
        "storage_key": "property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL6WfCXKUtocRcAs_y89aaz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3781a18a-6b0a-4c3e-a6b0-ae6bd2def2ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Jenks West Intermediate School",
      "poi_type": "Education",
      "poi_address": "909 N Adams St, Jenks, OK 74037, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jenksps.org/o/west-intermediate",
      "poi_directions_map_url": "https://maps.google.com/?cid=11723754934742872625&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-west-intermediate-school",
      "poi_latitude": "36.0296542",
      "poi_longitude": "-96.0017112",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927b-7730-8202-ef2e49d060cc",
        "storage_key": "property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5bj9Px-UtocRMfIUf_8ks6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_81083fb2-eb20-421f-b7e2-3de2ea046547",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Jenks High School",
      "poi_type": "Education",
      "poi_address": "205 E B St, Jenks, OK 74037, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-afcb-75a9-9779-1b20a9756f13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-afcb-75a9-9779-1b20a9756f13",
        "storage_key": "property/6767906449165614/019d7912-afcb-75a9-9779-1b20a9756f13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jenksps.org/o/high-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=4896344340347075511&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-high-school",
      "poi_latitude": "36.0257108",
      "poi_longitude": "-95.9692903",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927b-7730-8202-ef2e49d060cc",
        "storage_key": "property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ5df6ViRtocRt7thUDxP80M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_27f5a9a4-8876-4126-9cd2-d3431c25f37d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "McClure Elementary School",
      "poi_type": "Education",
      "poi_address": "1770 E 61st St, Tulsa, OK 74136, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-b02a-748c-bec6-30d32edec708.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b02a-748c-bec6-30d32edec708",
        "storage_key": "property/6767906449165614/019d7912-b02a-748c-bec6-30d32edec708.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mcclure.tulsaschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15452844710893318664&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mcclure-elementary-school",
      "poi_latitude": "36.0743872",
      "poi_longitude": "-95.9637727",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-746-8760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927b-7730-8202-ef2e49d060cc",
        "storage_key": "property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5-W-_HSTtocRCPIRUmSIc9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9b8d7ec6-5c4e-46b3-b43e-e9b95999fb46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Metro Christian Academy",
      "poi_type": "Education",
      "poi_address": "6363 S Trenton Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-b0f2-75af-a525-297d0c1561a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b0f2-75af-a525-297d0c1561a7",
        "storage_key": "property/6767906449165614/019d7912-b0f2-75af-a525-297d0c1561a7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.metroca.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7194184658093893380&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "metro-christian-academy",
      "poi_latitude": "36.0715055",
      "poi_longitude": "-95.9690922",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-745-9868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927b-7730-8202-ef2e49d060cc",
        "storage_key": "property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPyPO8Z2TtocRBGdAgtTg1mM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_8a6ebda4-15c0-482e-b2a4-7846fdf0652e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Spartan College - Flight Campus",
      "poi_type": "Education",
      "poi_address": "123 W Cessna Dr, Tulsa, OK 74132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-b0a4-75fb-b81c-1867f5e4c60a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b0a4-75fb-b81c-1867f5e4c60a",
        "storage_key": "property/6767906449165614/019d7912-b0a4-75fb-b81c-1867f5e4c60a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.spartan.edu/tulsa/flight-school/?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_content=website&utm_cid=7096",
      "poi_directions_map_url": "https://maps.google.com/?cid=12729979870499408822&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "spartan-college-flight-campus",
      "poi_latitude": "36.0376459",
      "poi_longitude": "-95.989805",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-393-3349",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927b-7730-8202-ef2e49d060cc",
        "storage_key": "property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0diqWA-UtocRtov98j75qbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_6f44722e-872b-4dc4-93c2-8abd5983766b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-b701-76d9-b5f8-b2e4c23ed2dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b701-76d9-b5f8-b2e4c23ed2dd",
        "storage_key": "property/6767906449165614/019d7912-b701-76d9-b5f8-b2e4c23ed2dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927b-7730-8202-ef2e49d060cc",
        "storage_key": "property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_daf3ea9f-52c9-46c5-96c8-48b19ee7d0cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Oklahoma State University Center for Health Sciences",
      "poi_type": "Education",
      "poi_address": "1111 W 17th St, Tulsa, OK 74107, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-bdfd-71fd-9f32-2185a357c0f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-bdfd-71fd-9f32-2185a357c0f4",
        "storage_key": "property/6767906449165614/019d7912-bdfd-71fd-9f32-2185a357c0f4.webp",
        "width": 1280,
        "height": 728
      },
      "poi_business_url": "https://medicine.okstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17254557055626874404&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-state-university-center-for-health-sciences",
      "poi_latitude": "36.1381886",
      "poi_longitude": "-96.0055344",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-582-1972",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927b-7730-8202-ef2e49d060cc",
        "storage_key": "property/6767906449165614/019cfb43-927b-7730-8202-ef2e49d060cc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ98PktRTrtocRJI5ZOTmAdO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_bde42623-348a-46c9-9fea-a73c34012f05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Sam's Club Pharmacy",
      "poi_type": "Restaurants",
      "poi_address": "7757 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-b77f-75da-992e-95b063afd266.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b77f-75da-992e-95b063afd266",
        "storage_key": "property/6767906449165614/019d7912-b77f-75da-992e-95b063afd266.webp",
        "width": 810,
        "height": 540
      },
      "poi_business_url": "https://www.samsclub.com/club/4839-tulsa-ok/pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=4117852476199145822&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club-pharmacy",
      "poi_latitude": "36.0510255",
      "poi_longitude": "-96.0038886",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-877-4592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7913-01cb-767d-a61b-40bbb1768914.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-01cb-767d-a61b-40bbb1768914",
        "storage_key": "property/6767906449165614/019d7913-01cb-767d-a61b-40bbb1768914.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnd74OGiUtocRXhFQgQKNJTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_fa119c32-cd0e-40db-8677-2478b607e094",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "la Madeleine",
      "poi_type": "Restaurants",
      "poi_address": "8115 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Quaint French cafe chain serving rustic country fare, espresso & fresh-baked baguettes.",
      "poi_long_description": "Diners say this restaurant serves delicious croissants, sandwiches, and onion soup. They also highlight the friendly and knowledgeable service, and the pleasant atmosphere.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-b9a8-707e-be35-044fe12c6906.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b9a8-707e-be35-044fe12c6906",
        "storage_key": "property/6767906449165614/019d7912-b9a8-707e-be35-044fe12c6906.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lamadeleine.com/locations/tulsa-hills",
      "poi_directions_map_url": "https://maps.google.com/?cid=9282201091564695797&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "la-madeleine",
      "poi_latitude": "36.045632",
      "poi_longitude": "-96.003685",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-289-0348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927e-71b7-9623-9739463fdbd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927e-71b7-9623-9739463fdbd2",
        "storage_key": "property/6767906449165614/019cfb43-927e-71b7-9623-9739463fdbd2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0xsUCD6UtocR9fB0rLYA0YA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6c6adffd-e27d-460c-a630-19ca1036865e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Chuy's",
      "poi_type": "Restaurants",
      "poi_address": "8120 S Olympia Ave W, Tulsa, OK 74132, USA",
      "poi_short_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_long_description": "People say this Tex-Mex restaurant serves delicious cheese dip, jalapeno ranch dip, and salsa. They also highlight the generous portions, fun atmosphere, and friendly service.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-c21d-757f-8c09-584dc7e415dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c21d-757f-8c09-584dc7e415dd",
        "storage_key": "property/6767906449165614/019d7912-c21d-757f-8c09-584dc7e415dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chuys.com/locations/ok/tulsa/tulsa-ok-the-walk/6061?cmpid=br:chy_ag:ie_ch:loc_ca:CHYGMB_sn:gmb_gt:tulsa-ok-6061_pl:locurl_rd:1059",
      "poi_directions_map_url": "https://maps.google.com/?cid=13906834356704269843&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chuy-s",
      "poi_latitude": "36.0457877",
      "poi_longitude": "-96.0054374",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-445-3007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927e-71b7-9623-9739463fdbd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927e-71b7-9623-9739463fdbd2",
        "storage_key": "property/6767906449165614/019cfb43-927e-71b7-9623-9739463fdbd2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaykmwT-UtocRE1aOdSoA_8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_e1fd168b-dbc4-4ca2-a55e-101cf147fdb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Ted's Café Escondido",
      "poi_type": "Restaurants",
      "poi_address": "7848 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Local chain serving traditional Mexican fare in a relaxed space with traditional touches.",
      "poi_long_description": "People say this Mexican restaurant serves delicious fajitas, tortilla soup, and sheet pan nachos, along with endless chips, salsa, queso, and fresh tortillas. They also highlight the generous portions, great value, and friendly, attentive service.\n\nSome reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-bf02-75ef-9f03-9e4054815352.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-bf02-75ef-9f03-9e4054815352",
        "storage_key": "property/6767906449165614/019d7912-bf02-75ef-9f03-9e4054815352.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tedscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8412124089736065572&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ted-s-caf-escondido",
      "poi_latitude": "36.0487725",
      "poi_longitude": "-96.0056556",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-301-8337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927e-71b7-9623-9739463fdbd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927e-71b7-9623-9739463fdbd2",
        "storage_key": "property/6767906449165614/019cfb43-927e-71b7-9623-9739463fdbd2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFTCUBECUtocRJHI5T0revXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d941fc6d-c6e5-4f9d-8c36-b63e64dc0997",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "7760 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "People say this fast food restaurant serves delicious burgers, chicken wraps, and breakfast items. They also highlight the friendly and welcoming staff, and the fast service.\n\nSome reviews mention that orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-c65e-7669-aa63-5e375ddf2203.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c65e-7669-aa63-5e375ddf2203",
        "storage_key": "property/6767906449165614/019d7912-c65e-7669-aa63-5e375ddf2203.webp",
        "width": 1280,
        "height": 1103
      },
      "poi_business_url": "https://locations.whataburger.com/ok/tulsa/7760-s-olympia-ave-w.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=6367328981041523019&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "36.0517435",
      "poi_longitude": "-96.0056001",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-445-7143",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927e-71b7-9623-9739463fdbd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927e-71b7-9623-9739463fdbd2",
        "storage_key": "property/6767906449165614/019cfb43-927e-71b7-9623-9739463fdbd2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQQV4mmUtocRS6kHA_lLXVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_0832a11f-92ca-471e-934d-bc483deee1b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Gung Ho - Tulsa Hills",
      "poi_type": "Restaurants",
      "poi_address": "7547 S Olympia Ave Suite B, Tulsa, OK 74132, USA",
      "poi_short_description": "Hand-pulled noodles and vibrantly colored poke bowls star at this Japanese restaurant.",
      "poi_long_description": "People say this ramen restaurant serves delicious ramen bowls, poke bowls, and sushi burritos. They highlight the fun, casual atmosphere with anime decor, and the generous portions. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-c8b2-76fe-8832-a2c4ba44f082.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c8b2-76fe-8832-a2c4ba44f082",
        "storage_key": "property/6767906449165614/019d7912-c8b2-76fe-8832-a2c4ba44f082.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.gunghonow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17484724921481262022&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gung-ho-tulsa-hills",
      "poi_latitude": "36.054413",
      "poi_longitude": "-96.0035454",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-699-9862",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927e-71b7-9623-9739463fdbd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927e-71b7-9623-9739463fdbd2",
        "storage_key": "property/6767906449165614/019cfb43-927e-71b7-9623-9739463fdbd2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMVvdGAqVtocRxnNPlK04pvI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "custom_6c1892bf-c3d6-4cc6-ae69-a08b8e228f6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Ashley Store",
      "poi_type": "Restaurants",
      "poi_address": "7831 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Retail chain with a variety of signature home furniture, decor, & accessories.",
      "poi_long_description": "People say this furniture store offers a wide selection of furniture, including living room sets, kitchen tables, and mattresses. They highlight the helpful and attentive service, and the efficient and knowledgeable staff. They also like the straightforward and effective purchase process.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-cfc1-7229-a531-8d913256ad87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cfc1-7229-a531-8d913256ad87",
        "storage_key": "property/6767906449165614/019d7912-cfc1-7229-a531-8d913256ad87.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://stores.ashleyfurniture.com/store/us/oklahoma/tulsa/7831-s-olympia-ave/?cmpid=ls-&utm_source=Local&utm_medium=LocalSEO&utm_campaign=LocalSearch",
      "poi_directions_map_url": "https://maps.google.com/?cid=16207957817893972259&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ashley-store",
      "poi_latitude": "36.049334",
      "poi_longitude": "-96.004164",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-461-7714",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-9288-77fd-a255-490a00cf60e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-9288-77fd-a255-490a00cf60e2",
        "storage_key": "property/6767906449165614/019cfb43-9288-77fd-a255-490a00cf60e2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ68fTl3yVtocRI-kVDsM77uA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_5b6785c8-2738-457a-9956-5748d5bb0a6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "DICK'S Sporting Goods",
      "poi_type": "Restaurants",
      "poi_address": "7523 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_long_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-cfd6-71bd-8cc4-8d3592d932c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cfd6-71bd-8cc4-8d3592d932c0",
        "storage_key": "property/6767906449165614/019d7912-cfd6-71bd-8cc4-8d3592d932c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.dickssportinggoods.com/ok/tulsa/1000/?seo=localpack",
      "poi_directions_map_url": "https://maps.google.com/?cid=2275925583343426123&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dick-s-sporting-goods",
      "poi_latitude": "36.0536757",
      "poi_longitude": "-96.0020156",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-447-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-9288-77fd-a255-490a00cf60e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-9288-77fd-a255-490a00cf60e2",
        "storage_key": "property/6767906449165614/019cfb43-9288-77fd-a255-490a00cf60e2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1TjN3WmUtocRS5poekK2lR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_28bcdfdd-74e2-4bb5-ad45-9f1069c49012",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Main Event Tulsa",
      "poi_type": "Entertainment",
      "poi_address": "7830 S Santa Fe Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Casual restaurant featuring bowling, laser tag and arcade games alongside an American menu.",
      "poi_long_description": "Visitors say this entertainment venue offers a wide variety of activities, including bowling, laser tag, and arcade games, and they praise the delicious pizza and drinks. They also highlight the family-friendly atmosphere, great deals, and friendly, helpful staff.\n\nSome reviews mention the games can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-d22a-742c-97ab-4674acb7986b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d22a-742c-97ab-4674acb7986b",
        "storage_key": "property/6767906449165614/019d7912-d22a-742c-97ab-4674acb7986b.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/oklahoma/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=15664382841071666320&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "main-event-tulsa",
      "poi_latitude": "36.0497894",
      "poi_longitude": "-96.0084228",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-447-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927e-71b7-9623-9739463fdbd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927e-71b7-9623-9739463fdbd2",
        "storage_key": "property/6767906449165614/019cfb43-927e-71b7-9623-9739463fdbd2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM0yApECUtocRkATNUzMRY9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_df050699-8d05-4552-8fcc-4db02cfb6240",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Page Belcher Golf Course",
      "poi_type": "Entertainment",
      "poi_address": "6666 S Union Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Golf course featuring 36 holes, practice facilities & lessons, plus a golf shop & an eatery.",
      "poi_long_description": "Golf course featuring 36 holes, practice facilities & lessons, plus a golf shop & an eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-d97b-70ec-95b5-1ddb428c77f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d97b-70ec-95b5-1ddb428c77f6",
        "storage_key": "property/6767906449165614/019d7912-d97b-70ec-95b5-1ddb428c77f6.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.tulsagolf.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=36008408697997651&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "page-belcher-golf-course",
      "poi_latitude": "36.0662366",
      "poi_longitude": "-96.0153338",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-446-1529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-c7e1-70a8-869e-1c3959b3f6fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-c7e1-70a8-869e-1c3959b3f6fd",
        "storage_key": "property/6767906449165614/019cfb43-c7e1-70a8-869e-1c3959b3f6fd.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQOzeFeUtocRUwlf-XTtfwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_73628ff1-0112-4e62-ba05-f2811115296e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Route 66 Historical Village",
      "poi_type": "Entertainment",
      "poi_address": "3770 Southwest Blvd, Tulsa, OK 74107, USA",
      "poi_short_description": "Free museum with the world's tallest oil rig and an event center, plus train displays and good views.",
      "poi_long_description": "People say this museum offers interesting historical artifacts, including a giant train engine and oil rig, and provides great photo opportunities. They also highlight the friendly and knowledgeable staff, and the clean and well-maintained grounds.\n\nOther reviews mention the building can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-dc88-75bd-801c-eeeaafc3f956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-dc88-75bd-801c-eeeaafc3f956",
        "storage_key": "property/6767906449165614/019d7912-dc88-75bd-801c-eeeaafc3f956.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.route66village.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14471635103474641910&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "route-66-historical-village",
      "poi_latitude": "36.1082878",
      "poi_longitude": "-96.0161309",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-619-9473",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-92c1-70b8-9b66-1e08f2add029.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-92c1-70b8-9b66-1e08f2add029",
        "storage_key": "property/6767906449165614/019cfb43-92c1-70b8-9b66-1e08f2add029.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42K2ctKUtocR9uut3XOT1cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7ccf1e3a-7235-4fb0-b0d6-cf0dfccca3a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "BOK Center",
      "poi_type": "Entertainment",
      "poi_address": "200 S Denver Ave., Tulsa, OK 74103, USA",
      "poi_short_description": "High-design, eco-conscious arena hosting professional sports plus concerts & festivals.",
      "poi_long_description": "Visitors say this arena hosts exciting hockey games and concerts, and they appreciate the friendly and helpful staff. They also highlight the clean facilities and easy access to parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-e1c6-72cd-b192-d52f63652485.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e1c6-72cd-b192-d52f63652485",
        "storage_key": "property/6767906449165614/019d7912-e1c6-72cd-b192-d52f63652485.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bokcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13467435354223455802&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bok-center",
      "poi_latitude": "36.1527314",
      "poi_longitude": "-95.996545",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-894-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927b-7730-8202-f1eed610918e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927b-7730-8202-f1eed610918e",
        "storage_key": "property/6767906449165614/019cfb43-927b-7730-8202-f1eed610918e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ966yH3frtocROq4G5Bnx5bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_86f335a9-f3d5-4312-bf03-0233d475aa24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Paintball Adventures, LLC",
      "poi_type": "Entertainment",
      "poi_address": "10242 S 49th W Ave, Sapulpa, OK 74066, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this paintball center offers a variety of fields and a comfortable pro shop. They highlight the low field fees and the friendly, accommodating staff. They also like the fun, low-key vibe and the helpful refs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-e8ee-734b-9d2f-5d476c01de54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e8ee-734b-9d2f-5d476c01de54",
        "storage_key": "property/6767906449165614/019d7912-e8ee-734b-9d2f-5d476c01de54.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sites.google.com/view/pbadventuresok/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=2468847232852757225&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "paintball-adventures-llc",
      "poi_latitude": "36.0150471",
      "poi_longitude": "-96.0490794",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-224-1055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927b-7730-8202-f1eed610918e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927b-7730-8202-f1eed610918e",
        "storage_key": "property/6767906449165614/019cfb43-927b-7730-8202-f1eed610918e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf_YpUwyWtocR6QrlTnobQyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "paintball_center"
    },
    {
      "id": "custom_a8783053-8c3c-4182-ac79-219639e3c24a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "River Spirit Casino Resort",
      "poi_type": "Entertainment",
      "poi_address": "8330 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Riverside casino offering a steakhouse, casual eateries, table & electronic gaming, & weekend shows.",
      "poi_long_description": "People say this casino offers a wide variety of slot machines, live music, and entertainment venues, including a concert venue and a sports bar. They also highlight the clean and spacious rooms with beautiful views, the friendly and helpful staff, and the convenient amenities such as free valet parking and keyless check-in.\n\nOther reviews mention the machines can be tight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-e606-73b1-81b7-aefd05b7ff4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e606-73b1-81b7-aefd05b7ff4e",
        "storage_key": "property/6767906449165614/019d7912-e606-73b1-81b7-aefd05b7ff4e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.riverspirittulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12292203165626239741&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "river-spirit-casino-resort",
      "poi_latitude": "36.0419162",
      "poi_longitude": "-95.9638914",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 888-748-3731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927b-7730-8202-f1eed610918e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927b-7730-8202-f1eed610918e",
        "storage_key": "property/6767906449165614/019cfb43-927b-7730-8202-f1eed610918e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJscNp2cGTtocR_YoV-qatlqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_b1a04488-6237-48e0-9d37-23661f754de0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Andy B's - Tulsa, OK",
      "poi_type": "Entertainment",
      "poi_address": "8711 S Lewis Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Family-friendly complex with bowling, laser tag, go-karts & games plus American eats & a pro shop.",
      "poi_long_description": "Visitors say this bowling alley offers a wide variety of entertainment options, including go-karts, laser tag, an arcade, and escape rooms. They also highlight the friendly and helpful staff, the clean environment, and the fun atmosphere for families and groups.\n\nSome reviews mention the wait times for go-karts can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019d7912-f4ac-76bd-bd36-c49b850ce8ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f4ac-76bd-bd36-c49b850ce8ff",
        "storage_key": "property/6767906449165614/019d7912-f4ac-76bd-bd36-c49b850ce8ff.webp",
        "width": 820,
        "height": 462
      },
      "poi_business_url": "https://bowlandybs.com/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=1068490842134744562&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "andy-b-s-tulsa-ok",
      "poi_latitude": "36.0379181",
      "poi_longitude": "-95.9540939",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-299-9494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-927b-7730-8202-f1eed610918e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-927b-7730-8202-f1eed610918e",
        "storage_key": "property/6767906449165614/019cfb43-927b-7730-8202-f1eed610918e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx__1HtuTtocR8g0zg8IK1A4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_96b61982-aed7-4b6c-9da1-8aea3183ffc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "poi_name": "Bales Baseball Park",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "bales-baseball-park",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_26ac14eb04800e9acaa86e6f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_728aaa39f98000b1b4a8b91a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_146f6c2b86ce71bc56018cf3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_23007be49a4460e0b5a197b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_fc470591f0e9f2595f472560",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_2f2da2b7383ae1b20cc78343",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_93a895b3-d04a-479a-b1ad-035650b3f377",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "rating": "5.0",
      "name": "Sandra Daniels",
      "text": "I turned in three maintenance requests on Friday morning and by the end of the day, Michael had come and taken care of all of them, efficiently, and in a very friendly and respectful manner as always. He’s the best! I’ve been here 12 years and Nickel Creek has always been very responsive to my maintenance needs.",
      "date": "2026-02-15",
      "title": ""
    },
    {
      "id": "custom_059c4338-a7a0-4ac6-b509-a56c96ecb744",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "rating": "5.0",
      "name": "Tom Armbruster",
      "text": "Maintenance person was awesome. Fixed my faucet quick and was very efficient. So far so good!!",
      "date": "2026-02-05",
      "title": ""
    },
    {
      "id": "custom_f3e4ff3f-8296-4381-8de0-3f4d2a4a6b3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "rating": "5.0",
      "name": "Salome Berry",
      "text": "Maintenance is always on time, and the location makes everything super convenient…. close to Tulsa Hills shopping like Target, Best Buy, and tons of great restaurants.",
      "date": "2026-01-29",
      "title": ""
    },
    {
      "id": "custom_42fb7202-e69d-4694-be0b-36761f4a814b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "rating": "5.0",
      "name": "Anthony Wallace",
      "text": "I moved into these apartments February 1st of this year and they have been great.! It’s peaceful , quiet and has a great atmosphere. I even like my neighbors. I have a balcony and carpet I love it.! Rent is even reasonable for a one bedroom.!!! Very spacious. I would definitely recommend someone to live here.",
      "date": "2025-08-23",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_408d2226-93c7-4b2c-8b2e-7c744287f093",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb44-372e-74ed-bdd1-cbbf9b88c7b3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of a resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb44-372e-74ed-bdd1-cbbf9b88c7b3",
        "storage_key": "property/6767906449165614/019cfb44-372e-74ed-bdd1-cbbf9b88c7b3.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Nickel Creek Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f744c7cffdaff4c251a4b31&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019c96cc-fb9b-7208-8ab4-60e5dde416df",
      "lead_source": "LANDING_PAGE",
      "name": "case-nickel-creek-apts-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614"
    },
    {
      "lead_collector_id": "019cf79e-4853-7276-9265-f0d4d01b80ca",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "nickel-creek-apts",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "nickel-creek-apts-in-unit-laundry-tulsa",
      "search_query": "apartments with in-unit laundry tulsa ok",
      "category": "Amenity",
      "h1_title": "Tulsa Apartments With In-Unit Laundry",
      "h2_subtitle": "Discover apartments with in-unit laundry at Nickel Creek. Enjoy the convenience of modern amenities in Tulsa, OK.",
      "page_copy": "Looking for apartments with in-unit laundry in Tulsa, OK? Welcome to Nickel Creek Apts, where modern conveniences harmonize with serene living. Our community offers spacious one and two-bedroom floor plans designed with high-end finishes and essential features. Not only do you benefit from in-unit laundry, but you can also enjoy amenities like a refreshing pool, a fully equipped fitness center, and scenic walking trails in your own backyard.\n\nLocated in the vibrant city of Tulsa, Nickel Creek Apts provides the ideal blend of comfort and convenience. Our community boasts 24-hour access and on-site management, ensuring your needs are met promptly. Whether you're relaxing in front of your fireplace or taking a stroll on the nearby trails, this is living at its finest. Embrace the Tulsa lifestyle with an apartment that offers everything you need right at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tulsa Apartments With In-Unit Laundry",
      "seo_description": "Explore Nickel Creek Apts in Tulsa, OK offering spacious layouts and in-unit laundry for ultimate convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "nickel-creek-apts-air-conditioned-tulsa",
      "search_query": "air conditioned apartments in tulsa",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Tulsa",
      "h2_subtitle": "Enjoy air conditioned apartments at Nickel Creek, Tulsa. Experience the perfect blend of comfort and convenience.",
      "page_copy": "Searching for air conditioned apartments in Tulsa? Look no further than Nickel Creek Apts. Our community offers you not just air conditioning but also a variety of spacious one and two-bedroom floor plans packed with modern amenities. Relax and cool off in our refreshing pool, or keep fit in our state-of-the-art fitness center—all while enjoying the comfort of air conditioning in your own home.\n\nSituated amidst tranquil surroundings, Nickel Creek Apts ensures your ultimate comfort with air conditioned interiors and convenient on-site management. Located in Tulsa, OK, you’ll find everything you need, from a cozy fireplace to picnic areas perfect for gatherings. Discover a community that prioritizes your comfort in every season, making Nickel Creek the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Tulsa",
      "seo_description": "Nickel Creek Apts in Tulsa offers air conditioned apartments, modern layouts, and top amenities for a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "nickel-creek-apartments-swimming-pool-tulsa",
      "search_query": "nickel creek apartments with swimming pool",
      "category": "Amenity",
      "h1_title": "Nickel Creek Apartments With Swimming Pool",
      "h2_subtitle": "Dive into relaxation with our swimming pool at Nickel Creek Apartments. Enjoy ultimate leisure and comfort in Tulsa, OK.",
      "page_copy": "Welcome to Nickel Creek Apartments, where leisure meets modern living in Tulsa, OK. Our swimming pool is a centerpiece of relaxation, offering residents a refreshing retreat right at home. Whether you're planning a leisurely swim or a sunbathing day by the water, our pool is the ideal spot to unwind from daily stresses. \n\nIn addition to our inviting pool, Nickel Creek Apartments offers a plethora of amenities including spacious one and two-bedroom floor plans, a fully-equipped fitness center, and serene walking trails. Enjoy 24-hour access and attentive on-site management, ensuring a seamless living experience. Discover comfort and convenience in a community that values your relaxation and enjoyment every day.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nickel Creek Apts With Swimming Pool",
      "seo_description": "Discover leisure at Nickel Creek Apartments with a swimming pool in Tulsa, OK. Experience modern living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "nickel-creek-apartments-near-dog-park-tulsa",
      "search_query": "apartments near dog park in tulsa",
      "category": "Amenity",
      "h1_title": "Apartments Near Dog Park in Tulsa",
      "h2_subtitle": "Explore Nickel Creek Apartments located near a dog park in Tulsa. Enjoy pet-friendly living and modern amenities.",
      "page_copy": "Looking for the perfect pet-friendly community? Nickel Creek Apartments is located near a popular dog park in Tulsa, making it an ideal home for both you and your furry friend. Relish the convenience of having an open space nearby where your dog can run and play, all while enjoying a range of modern amenities at home.\n\nNestled in a serene Tulsa neighborhood, Nickel Creek Apartments offers spacious one and two-bedroom floor plans with features like a refreshing pool, fitness center, and cozy fireplaces. With 24-hour access and on-site management, you can rest assured that your living experience will be seamless and pet-friendly. Discover a community where both you and your pet can thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tulsa Apartments Near Dog Park",
      "seo_description": "Nickel Creek Apartments offers pet-friendly living near a dog park in Tulsa, OK. Enjoy spacious layouts and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "nickel-creek-apartments-fitness-center-tulsa",
      "search_query": "tulsa apartments with fitness center",
      "category": "Amenity",
      "h1_title": "Tulsa Apartments With Fitness Center",
      "h2_subtitle": "Maintain your active lifestyle at Nickel Creek Apartments with a top-notch fitness center right in Tulsa.",
      "page_copy": "Stay fit and healthy with ease at Nickel Creek Apartments, where our modern fitness center is just steps away from your home in Tulsa, OK. Offering a range of equipment suitable for all workout routines, our fitness center caters to both beginners and seasoned athletes. Embrace the convenience of getting in a great workout without having to leave the community.\n\nNickel Creek Apartments not only supports your fitness goals but also provides a variety of other amenities, including a refreshing pool, spacious one and two-bedroom options, and beautiful walking trails. With 24-hour access and on-site management, we strive to make your living experience comfortable and enjoyable. Experience a lifestyle where health and modern living meet effortlessly in Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tulsa Apartments With Fitness Center",
      "seo_description": "Discover Nickel Creek Apartments in Tulsa, featuring a top-notch fitness center and a range of modern amenities for an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-tulsa-nickel-creek",
      "search_query": "1 bedroom apartments tulsa ok",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Tulsa, OK",
      "h2_subtitle": "Discover charming 1 bedroom apartments at Nickel Creek in Tulsa, OK. Enjoy a blend of comfort and modern amenities.",
      "page_copy": "Nickel Creek Apartments offers beautifully designed 1 bedroom apartments in Tulsa, OK, perfect for those seeking a cozy and comfortable living space. Our one-bedroom layouts are thoughtfully crafted with modern touches and conveniences, ensuring a welcoming environment for you to call home. From relaxing evenings by your fireplace to scenic walks on our trails, experience the lifestyle you deserve.\n\nEnjoy access to a wealth of amenities including a refreshing swimming pool, a fully-equipped fitness center, and convenient picnic areas. Nickel Creek Apartments offers 24-hour access and on-site management services, so you can enjoy hassle-free living. Discover why residents love calling Nickel Creek home and see the difference our community makes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Tulsa, OK",
      "seo_description": "Explore 1 bedroom apartments at Nickel Creek in Tulsa, OK. Enjoy comfort, modern amenities, and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-74132-nickel-creek",
      "search_query": "2 bedroom apartments near 74132",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 74132",
      "h2_subtitle": "Find spacious 2 bedroom apartments near the 74132 area at Nickel Creek Apts. Enjoy comfort and a vibrant community.",
      "page_copy": "Searching for spacious 2 bedroom apartments near the 74132 ZIP code? Nickel Creek Apartments offers the ideal blend of comfort and modern living. Nestled in a serene part of Tulsa, our two-bedroom layouts provide ample space and high-end finishes, perfect for families or roommates.\n\nLocated in close proximity to Tulsa's vibrant areas yet offering a peaceful retreat, Nickel Creek Apartments provides amenities such as a refreshing pool, fitness center, and picnic spots. With 24-hour access and excellent management, you’re sure to enjoy a seamless lifestyle. Choose Nickel Creek as your next home and experience the best of Tulsa living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 74132",
      "seo_description": "Discover spacious 2 bedroom apartments near Tulsa's 74132 at Nickel Creek Apts. Enjoy modern living and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "apartments-near-oral-roberts-university-nickel-creek",
      "search_query": "apartments near oral roberts university tulsa ok",
      "category": "School",
      "h1_title": "Apartments Near Oral Roberts University",
      "h2_subtitle": "Find ideal living at Nickel Creek Apartments near Oral Roberts University in Tulsa, OK. Enjoy exceptional amenities and comfortable living spaces.",
      "page_copy": "Nickel Creek Apartments offers an excellent option for those seeking apartments near Oral Roberts University in Tulsa, OK. Ideal for students or faculty, our community provides a convenient location combined with a comfortable living environment. Choose from spacious one and two-bedroom floor plans equipped with modern amenities that suit a busy lifestyle.\n\nEnjoy relaxing by the pool, getting in a workout at the fitness center, or unwinding in our charming picnic areas. With 24-hour access and supportive on-site management, living at Nickel Creek is both easy and enjoyable. Discover a welcoming community designed to support your educational journey and personal growth.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oral Roberts University",
      "seo_description": "Explore Nickel Creek Apartments near Oral Roberts University in Tulsa, OK. Enjoy modern amenities and convenient living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "apartments-close-to-tcc-west-campus-nickel-creek",
      "search_query": "apartments close to tulsa community college west campus",
      "category": "School",
      "h1_title": "Apartments Close to Tulsa Community College",
      "h2_subtitle": "Discover apartments near Tulsa Community College West Campus at Nickel Creek. Enjoy modern amenities and a welcoming community.",
      "page_copy": "Nickel Creek Apartments is the perfect choice for anyone seeking apartments close to Tulsa Community College's West Campus. Our community offers the convenience of proximity paired with the comfort of spacious living, making it an ideal option for students and faculty alike. With easy access to educational resources, living at Nickel Creek facilitates both academic and personal success.\n\nOur property features modern one and two-bedroom apartments equipped with high-end amenities such as a fitness center, swimming pool, and scenic picnic areas. Residents can enjoy the benefits of 24-hour access along with attentive on-site management. Join the Nickel Creek community and experience seamless, supportive living tailored to your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Tulsa Community College",
      "seo_description": "Discover comfortable apartments at Nickel Creek near Tulsa Community College West Campus. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "ou-tulsa-nearby-apartments-nickel-creek",
      "search_query": "ou-tulsa nearby apartments",
      "category": "School",
      "h1_title": "OU-Tulsa Nearby Apartments",
      "h2_subtitle": "Explore nearby apartments to OU-Tulsa at Nickel Creek. Enjoy modern amenities and the comfort of a vibrant community.",
      "page_copy": "Nickel Creek Apartments provides the perfect solution for those seeking nearby apartments to OU-Tulsa. Offering a convenient and comfortable living environment, our community is designed to cater to the needs of students and professionals alike. Featuring spacious one and two-bedroom layouts, each apartment is equipped with modern conveniences to support busy lifestyles.\n\nResidents at Nickel Creek enjoy premium amenities such as a well-equipped fitness center, a refreshing pool, and beautifully maintained picnic areas. Complete with 24-hour access and exceptional on-site management, living at Nickel Creek allows you to thrive both academically and personally. Choose our community for easy access to OU-Tulsa and a warm, inviting residential atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "OU-Tulsa Nearby Apartments",
      "seo_description": "Find nearby apartments to OU-Tulsa at Nickel Creek. Enjoy excellent amenities and a supportive community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "apartments-near-saint-francis-hospital-tulsa-nickel-creek",
      "search_query": "apartments near Saint Francis Hospital Tulsa",
      "category": "Hospital",
      "h1_title": "Apartments Near Saint Francis Hospital",
      "h2_subtitle": "Discover comfortable living at Nickel Creek, ideally situated near Saint Francis Hospital Tulsa. Enjoy premium amenities and a welcoming community.",
      "page_copy": "Nickel Creek Apartments is the top choice for those searching for apartments near Saint Francis Hospital in Tulsa. Perfectly positioned for healthcare professionals and hospital visitors, our community offers a blend of convenience and modern living. Choose from our spacious one and two-bedroom floor plans, designed to provide comfort and style.\n\nOur amenities include a state-of-the-art fitness center, a relaxing pool, and serene picnic areas, ensuring a delightful living experience. With 24-hour access and responsive on-site management, accommodations at Nickel Creek support a hassle-free lifestyle. Enjoy the proximity to Saint Francis Hospital and relish the peace of mind that comes with exceptional living conditions at Nickel Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Francis Hospital",
      "seo_description": "Explore Nickel Creek Apartments near Saint Francis Hospital Tulsa. Modern amenities and a vibrant community await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "apartments-close-to-saint-francis-childrens-hospital-ok-nickel-creek",
      "search_query": "apartments close to Saint Francis Children's Hospital OK",
      "category": "Hospital",
      "h1_title": "Apartments Close to Saint Francis Children's",
      "h2_subtitle": "Find ideal apartments close to Saint Francis Children's Hospital at Nickel Creek. Enjoy a family-friendly and amenity-rich community.",
      "page_copy": "Nickel Creek Apartments provides an exceptional living experience for those seeking apartments close to Saint Francis Children's Hospital in Tulsa. Our community is perfect for healthcare workers, patient families, and anyone looking for comfort and convenience near their workplace or medical services. Our spacious one and two-bedroom options are designed with modern features and family-friendly environments in mind.\n\nResidents enjoy a range of amenities that make every day feel like a retreat, including a well-equipped fitness center, a refreshing pool, and inviting picnic areas. With 24-hour access and attentive on-site management, we ensure a smooth and accommodating living experience. Nickel Creek Apartments offers the ideal balance of proximity and quality for those needing to be near Saint Francis Children's Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Saint Francis Children's",
      "seo_description": "Discover Nickel Creek Apartments, close to Saint Francis Children's Hospital. Enjoy modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "apartments-near-gathering-place-tulsa-nickel-creek",
      "search_query": "apartments near gathering place tulsa",
      "category": "Park",
      "h1_title": "Apartments Near Gathering Place Tulsa",
      "h2_subtitle": "Live near the vibrant Gathering Place in Tulsa at Nickel Creek Apartments. Enjoy modern amenities and a welcoming community just minutes away.",
      "page_copy": "Nickel Creek Apartments is the perfect choice for those looking to live near the iconic Gathering Place in Tulsa. Our community offers a convenient location paired with resort-style amenities, ideal for those who want active living with easy park access. Choose from spacious and well-designed one or two-bedroom apartment homes, each filled with high-end features and comforts.\n\nThe on-site amenities at Nickel Creek include a refreshing pool, a fully-equipped fitness center, and delightful picnic areas, offering plenty of options for relaxation and recreation. With 24-hour access and dedicated on-site management, convenience is always a priority. Experience vibrant living in a serene setting while being just minutes away from Tulsa's renowned Gathering Place when you make Nickel Creek your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Gathering Place Tulsa",
      "seo_description": "Explore Nickel Creek Apartments, conveniently located near Gathering Place Tulsa. Experience modern living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "nickel-creek-apts-close-to-woodward-park",
      "search_query": "nickel creek apts close to woodward park",
      "category": "Park",
      "h1_title": "Nickel Creek Apts Near Woodward Park",
      "h2_subtitle": "Discover Nickel Creek Apts, conveniently close to Woodward Park. Enjoy serene settings with modern amenities, perfect for lovers of nature and comfort.",
      "page_copy": "Nickel Creek Apartments offers a wonderful community setting for those who want to enjoy proximity to the beautiful Woodward Park in Tulsa. Our residences provide an ideal living environment for nature lovers and anyone looking to experience the peacefulness of nearby green spaces. Choose between spacious one and two-bedroom apartments that come equipped with high-end features and modern conveniences.\n\nWith amenities like a refreshing swimming pool, well-equipped fitness center, and inviting picnic areas, residents can unwind and take advantage of all that Nickel Creek offers. Our 24-hour access and responsive on-site management ensure that your needs are met promptly. Enjoy the peace of living close to the tranquil oasis of Woodward Park, coupled with the vibrant amenities Nickel Creek provides.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nickel Creek Apts Near Woodward Park",
      "seo_description": "Live at Nickel Creek Apartments, close to Woodward Park. Enjoy modern amenities and serene surroundings in Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "lafortune-park-nearby-nickel-creek-tulsa",
      "search_query": "lafortune park nearby nickel creek tulsa",
      "category": "Park",
      "h1_title": "LaFortune Park Near Nickel Creek Tulsa",
      "h2_subtitle": "Enjoy living near LaFortune Park at Nickel Creek Tulsa. Discover a vibrant community close to outdoor fun and modern comforts.",
      "page_copy": "Experience an active lifestyle with Nickel Creek Apartments, ideally situated near the expansive LaFortune Park in Tulsa. Perfectly suited for those who appreciate outdoor activities, our community offers easy access to the park's golf course, tennis courts, and scenic trails. Nickel Creek provides an inviting residence choice with well-appointed one and two-bedroom apartments.\n\nOur community features modern amenities such as a refreshing pool, a well-equipped fitness center, and delightful picnic spots, creating a perfect blend of urban convenience and natural beauty. With 24-hour access and attentive on-site management, residents can enjoy stress-free living. Discover the balance of relaxation and recreation at Nickel Creek, located just a short distance from the beloved LaFortune Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "LaFortune Park Near Nickel Creek Tulsa",
      "seo_description": "Explore Nickel Creek Apartments near LaFortune Park Tulsa. Enjoy modern amenities and proximity to great outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "apartments-by-hunter-park-tulsa-ok",
      "search_query": "apartments by hunter park tulsa ok",
      "category": "Park",
      "h1_title": "Apartments by Hunter Park Tulsa, OK",
      "h2_subtitle": "Find your new home at Nickel Creek Apts near Hunter Park. Enjoy Tulsa living with modern amenities in a vibrant community setting.",
      "page_copy": "Nickel Creek Apartments offers a prime location for those seeking residences near Hunter Park in Tulsa, OK. Our community is perfectly positioned for anyone who loves the outdoors and wants easy access to the park's natural beauty and recreational options. Choose from spacious one or two-bedroom floor plans designed with comfort and style in mind.\n\nResidents at Nickel Creek enjoy high-end amenities, including a refreshing swimming pool, an equipped fitness center, and inviting picnic areas, ideal for gatherings or lounging. With 24-hour access and a responsive on-site management team, convenience is a cornerstone of living at Nickel Creek. Nestled in a serene residential area, our apartments offer a desirable blend of tranquil park proximity and vibrant community lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Hunter Park Tulsa, OK",
      "seo_description": "Discover Nickel Creek Apartments, ideally located near Hunter Park Tulsa, OK. Enjoy a modern lifestyle with great amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165614",
      "source": "generator",
      "page_item_url": "turkey-mountain-apartments-near-nickel-creek",
      "search_query": "turkey mountain apartments tulsa county near nickel creek",
      "category": "Park",
      "h1_title": "Turkey Mountain Apartments Near Nickel Creek",
      "h2_subtitle": "Explore Turkey Mountain apartments in Tulsa County, close to Nickel Creek. Enjoy natural beauty and modern living in this prime location.",
      "page_copy": "Nickel Creek Apartments sits charmingly close to the scenic landscapes of Turkey Mountain in Tulsa County, offering an ideal setting for those seeking convenient access to outdoor adventure. Enjoy both the rugged trails of Turkey Mountain and the modern comforts of home at Nickel Creek, where you're never far from nature or urban amenities.\n\nChoose from thoughtfully designed one and two-bedroom apartments, complete with high-end features like a pool, a fitness center, and delightful picnic spots. With 24-hour access and dedicated on-site management, residents enjoy a seamless living experience. Whether hiking the trails at Turkey Mountain or relaxing at home, Nickel Creek Apartments offers the perfect balance of excitement and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb43-6a22-710d-ac39-a6a7d9593707",
        "storage_key": "property/6767906449165614/019cfb43-6a22-710d-ac39-a6a7d9593707.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Turkey Mountain Apts Near Nickel Creek",
      "seo_description": "Find Turkey Mountain apartments near Nickel Creek. Enjoy Tulsa County living with access to nature and luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5190"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-200J5EWMXE"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151483"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/nickel-creek/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MTQXM2VD"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165614/019d1bd8-e98e-7668-bc90-085e1375f02d.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "49866593977"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "e4b86574-4784-4ad4-bcf5-eb34dafb9e8d"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "855-756-4817"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64651db2f1c79e9da252054e"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkVDc1ZXOHZ0Ky9vRnViMmM4K2RRM3c9PSIsInZhbHVlIjoiSXZkWThhdVRIbjZqb2p4WWJ6NS9WQT09IiwibWFjIjoiOWQwNTZkYTcwOWRiM2I1NDY5ZjEzNjY1YmUyMTUzOTVjYTIxNDMwYjAwNjIzMDQyZGI5NTQ5MTczMmRkNjkxZiJ9"
    }
  ],
  "custom_qb_id": "5190",
  "custom_ga4_id": "G-200J5EWMXE",
  "custom_repli_id": "10041151483",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/nickel-creek/register/",
  "custom_google_gtm_id": "GTM-MTQXM2VD",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165614/019d1bd8-e98e-7668-bc90-085e1375f02d.pdf",
  "custom_hubspot_company_id": "49866593977",
  "custom_rentgrata_property_id": "e4b86574-4784-4ad4-bcf5-eb34dafb9e8d",
  "custom_ppc_tracking_phone_number": "855-756-4817",
  "custom_residentboost_apartment_id": "64651db2f1c79e9da252054e",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkVDc1ZXOHZ0Ky9vRnViMmM4K2RRM3c9PSIsInZhbHVlIjoiSXZkWThhdVRIbjZqb2p4WWJ6NS9WQT09IiwibWFjIjoiOWQwNTZkYTcwOWRiM2I1NDY5ZjEzNjY1YmUyMTUzOTVjYTIxNDMwYjAwNjIzMDQyZGI5NTQ5MTczMmRkNjkxZiJ9"
};

export const generatedAt = '2026-08-27T21:37:30.974Z';
